export const TRANSLATIONS_EN = {
    "In force": "In force",
    "New proposal": "New proposal",
    "Number of ads": "Number of ads",
    "For a total amount of": "For a total amount of",
    "Finalization": "Finalization",
    "Condition": "Condition",
    "Valid": "In force",
    "Expired": "Expired",
    "Real spots": "Real playouts",
    "Purchased spots": "Purchased playouts",
    "Screens quantity": "Screens quantity",
    "Created by": "Created by",
    "Created on": "Created on",
    "DSP": "DSP",
    "Traditional campaign": "Traditional campaign",
    "Relaunch": "Relaunch",
    "Delete payment": "Delete payment",
    "Are you sure you want to delete this payment?": "Are you sure you want to delete this payment?",
    "There is already a pending payment for this campaign.": "There is already a pending payment for this campaign.",
    "Screens map": "Screens map",
    "Ads per screen": "Ads per screen",
    "Ad": "Ad",
    "There are no rules applied to this ad": "There are no rules applied to this ad",
    "The owner of this screen does not use cms": "The publisher of this screen does not use cms",
    "New campaign": "New campaign",
    "Select client": "Select client",
    "Archive": "Archive",
    "Unarchive": "Unarchive",
    "Duplicate": "Duplicate",
    "Approved ads": "Approved ads",
    "Grid view": "Grid view",
    "List view": "List view",
    "Operation completed successfully": "Operation completed successfully",
    "This action cannot be undone.": "This action cannot be undone.",
    "Do you want to archive this campaign?": "Do you want to archive this campaign?",
    "Do you want to unarchive this campaign?": "Do you want to unarchive this campaign?",
    "This function is not available yet": "This function is not available yet",
    "Welcome to React": "EN",

    //Language
    "es": "Español",
    "es_ar": "Español (Argentina)",
    "en": "English",
    "Search": "Search",
    "language iso 639-1": "EN",

    // Buttons
    "Continue": "Continue",
    "Accept": "Accept",

    // Top bar component
    "I offered your screens": "Offer your screens",
    "My campaigns": "My campaigns",
    "Go to CMS": "Go to CMS",
    "My profile": "My profile",
    "Sign off": "Sign off",
    "Sign up": "Sign up",
    "Sign up as an agency": "Sign up as an agency",
    "Sign up as an advertiser": "Sign up as an advertiser",
    "Log in": "Log in",
    "Login": "Login",
    "Screen manager": "CMS",
    "Agency Account": "Agency Account",
    "My quotes": "My quotes",
    "My proposals": "My proposals",
    "Daily consumption of the campaign": "Daily consumption of the campaign",
    "Total consumption of all screens (per day)": "Total consumption of all screens (per day)",
    "Total campaign": "Total campaign",
    "consumption_per_day": "Consumption in {{currency}} per day",
    "consumption_accumulated": "Accumulated consumption in {{currency}}",
    "Password": "Password",
    "Password must be at least 6 characters": "Password must be at least 6 characters",

    "Code2FA": "Security code",
    "To log in, you must enable two-factor authentication (2FA) by accessing the CMS.": "To log in, you must enable two-factor authentication (2FA) by accessing the CMS.",
    "I forgot my password": "I forgot my password",
    "Dont have an account?": "Don't have an account?",
    "Do you already have your account?": "Do you already have your account?",
    "Are you a media owner?": "Are you a publisher?",
    "Register here": "Register here",
    "Create company account": "Create company account",
    "Recover your password": "Recover your password",
    "Enter your email and we will send you the instructions to reset your password.": "Enter your email and we will send you the instructions to reset your password.",
    "Send instructions": "Send instructions",
    "Resend verification email": "Resend verification email",
    "Enter your email and we will resend you the verification instructions.": "Enter your email and we will resend you the verification instructions.",
    "Resend email": "Resend email",
    "Name": "Name",
    "First Name": "First Name",
    "Last name": "Last name",
    "Phone": "Phone",
    "Data entered correctly, we will send you an email when we confirm your data.": "Data entered correctly, we will send you an email when we confirm your data.",
    "Session closed successfully": "Session closed successfully",
    "Welcome": "Welcome",
    "Error sending email": "Error sending email",
    "Selected screens must have the same currency": "Selected screens must have the same currency",
    "Good! An email was sent to your mailbox to retrieve your password.": "Good! An email was sent to your mailbox to retrieve your password.",
    "Good! An email was sent to your mailbox to activate yout account.": "Good! An email was sent to your mailbox to activate yout account.",
    "Good! Just one step left, activate your account.": "Good! Just one step left, activate your account.",
    "Good! You just need to verify your email": "Good! You just need to verify your email",
    "To begin you must verify your email. Check your email box to complete the registration process. Remember to check your spam folder.": "To begin you must verify your email. Check your email box to complete the registration process. Remember to check your spam folder.",
    "In order to use your account you have to activate it. Check your email address to finish the registration process.": "In order to use your account you have to activate it. Check your email address to finish the registration process. Remeber to check the spam folder.",
    "Url whatsapp, Hello, I would like to have advice publinet": "https://api.whatsapp.com/send?phone=5492615019508&text=Hello,%20I%20would%20like%20to%20have%20advice.",
    "Url whatsapp, Hello, I would like to have advice latinad": "https://api.whatsapp.com/send?phone=5492615019508&text=Hello,%20I%20would%20like%20to%20have%20advice.",
    "Url whatsapp, Hello, I would like to have advice fenix": "https://api.whatsapp.com/send?phone=14073752728&text=Hi,%20I%20would%20like%20to%20have%20advice.",
    "Url whatsapp, Hello, I would like to have advice mediashake": "https://api.whatsapp.com/send?phone=573107964234&text=Hello,%20I%20want%20more%20information%20about%20MediaShake...",
    "Url whatsapp, Hello, I would like to have advice duoprint": "https://api.whatsapp.com/send?phone=593999560300&text=Hello,%20I%20want%20more%20information%20about%20DuoPrint...",
    "Url whatsapp, Hello, I would like to have advice hak media": "https://api.whatsapp.com/send?phone=56935574177&text=Hello,%20I%20want%20more%20information%20about%20%20Hakmedia...",
    "Currency": "Currency",
    "Terms": "Terms and Conditions",
    "Content Manager System": "Content Manager System",
    "Screen Player": "Screen Player",
    "Supply Side Platform": "Supply Side Platform",
    "Audience measurement": "Audience measurement",
    "Static OOH platform": "Static OOH platform",

    // Footer
    "You can start creating your campaign by entering the zone and date.": "You can star to create your campaign by entering zone and date.",
    "Advertisers": "Advertisers",
    "Create campaign": "Create campaign",
    "I am an agency": "I am an agency",
    "Purchase advice": "Purchase advice",
    "Offer your screens": "Offer your screens",
    "SSP": "SSP",
    "Product": "Product",
    "Certifications": "Certifications",
    "Community": "Community",
    "Success cases": "Success cases",
    "Plan your campaign": "Plan your campaign",
    "in the right place": "in the right place",
    "Technological solutions for the DOOH industry": "Technological solutions for the DOOH industry",

    "Contact": "Contact",
    "Write us by whatsapp": "Chat on WhatsApp",
    "Speak with us": "Speak with us",
    "Work with us": "Work with us",
    "Help": "Help",

    // TODO: not implemented
    "Hello, I would like to work with you. I leave information about me:": "Hola, me gustaría trabajar con ustedes. Les dejo información sobre mi:",

    "Url whatsapp, I am an agency publinet": "https://api.whatsapp.com/send?phone=5492615019508&text=Hello,%20I%20have%20an%20agency%20and%20I%20would%20like%20to%20be%20able%20to%20operate%20through%20the%20platform.",
    "Url whatsapp, I am an agency latinad": "https://api.whatsapp.com/send?phone=50254828708&text=Hello,%20I%20have%20an%20agency%20and%20I%20would%20like%20to%20be%20able%20to%20operate%20through%20the%20platform.",

    "Url whatsapp, Purchase advice publinet": "https://api.whatsapp.com/send?phone=5492615019508&text=Hello,%20I%20want%20to%20do%20a%20campaign%20I%20would%20like%20to%20have%20advice.",
    "Url whatsapp, Purchase advice latinad": "https://api.whatsapp.com/send?phone=5492615019508&text=Hello,%20I%20want%20to%20do%20a%20campaign%20I%20would%20like%20to%20have%20advice.",

    "Mailto Work with us": "mailto:info@latinad.com?subject=I want to work with you&amp;body=Hello, I would like to work with you. I leave information about me:",

    "Our social networks": "Our social networks",
    "Find out about the latest news of the platform on our social networks.": "Find the latest updates on the platform on our social networks.",

    // SearchBoxComponent
    "Campaign location": "Campaign location",
    "Add Country or City?": "Add Country or City?",
    "Campaign start": "Campaign start",
    "End of campaign": "End of campaign",
    "Add dates": "Add dates",
    "Select a customer and brand to continue": "Select a customer and brand to continue",
    "Enter brief to continue": "Enter brief to continue",
    "Traditional": "Traditional",
    "Programmatic": "Programmatic",
    "Classic version": "Classic version",
    "AI Planner": "AI Planner",
    "Campaign brief": "Campaign brief",
    "Optimize brief": "Optimize brief",
    "IA Brief": "IA Brief",
    "New brief": "New brief",
    "Continue with this brief": "Continue with this brief",
    "Optimizing brief...": "Optimizing brief...",
    "Error optimizing brief": "Error optimizing brief",
    "Skip": "Skip",
    "Client": "Client",
    "Mark": "Brand",
    "": "",
    "To select a client, you must first create it in the “Clients” section of the CMS and then create the associated brand. Click on the <icon/> to learn how to do it.": "To select a client, you must first create it in the “Clients” section of the CMS and then create the associated brand. Click on the  <icon/>  to learn how to do it.",

    //CampaignModal
    "Dark mode": "Dark mode",
    "Light mode": "Light mode",
    "Theme": "Theme",
    "Campaign Information": "Campaign Information",
    "Configure the basic details of your campaign": "Configure the basic details of your campaign",
    "Add campaign zone": "Add campaign zone",
    "Campaign amount": "Campaign amount",
    "Campaign category": "Campaign category",
    "Next step": "Next",
    "Back": "Back",
    "Done": "Done",
    "Segmentation": "Segmentation",
    "segmented": "segmented",
    "inclusive": "inclusive",
    "Define your audience's demographics and points of interest": "Define your audience's demographics and points of interest",
    "Men": "Men",
    "Women": "Women",
    "Ages": "Ages",
    "Points of interest": "Points of interest",
    "Add point of interest": "Add point of interest",
    "Types of screens": "Types of screens",
    "Types": "Types",
    "types": "types",
    "Specify the types and subtypes of screens to use": "Specify the types and subtypes of screens to use",
    "Explore proposals": "Explore proposals",
    "Creating proposals": "Creating proposals",
    "AI_justification_hint": "Click the icon next to each section to get AI justifications",
    "loading_justifications": "Loading AI justifications...",
    "Objectives": "Objectives",
    "Strategy": "Strategy",
    "Justification": "Justification",
    "The sum of men and women must equal 100%": "The sum of men and women must equal 100%",
    "The total for all brackets must equal 100%": "The total for all brackets must equal 100%",
    "How do you want to work today?": "How do you want to work today?",

    //Brackets
    "Level": "Level",
    "LEVEL_A_INFO": "The highest socioeconomic level, which includes individuals with very high incomes, advanced education and high-status occupations. This group usually has a high purchasing power and access to luxury goods and services.",
    "LEVEL_B_INFO": "This level includes individuals with high incomes, but not as high as level A. They usually have good education and middle-high status occupations.",
    "LEVEL_C_INFO": "Refers to the middle class, with moderate incomes and education. Occupations may be administrative, technical or management level medium.",
    "LEVEL_D_INFO": "Includes individuals with low to moderate incomes, lower education and lower status occupations. Often, this group faces certain limitations in their purchasing power.",
    "LEVEL_E_INFO": "The lowest socioeconomic level, which includes individuals with very low incomes, basic education and low-status or unemployment. This group usually has limited access to goods and services.",

    "years": "years",
    "CHILDREN": "Children",
    "CHILDREN_INFO": "0-14 years",
    "TEENS": "Teens",
    "TEENS_INFO": "15-19 years",
    "YOUNG_ADULTS": "Young adults",
    "YOUNG_ADULTS_INFO": "20-29 years",
    "MIDLIFE_ADULTS": "Middle-aged adults",
    "MIDLIFE_ADULTS_INFO": "30-44 years",
    "MATURE_ADULTS": "Mature adults",
    "MATURE_ADULTS_INFO": "45-54 years",
    "SENIOR": "Senior",
    "SENIOR_INFO": "55 years and older",

    // HomeComponent
    "Digital signage": "Digital signage",
    "Digital signage (DOOH)": "Digital signage (DOOH)",
    "High-Value Audiences at a Click": "High-Value Audiences at a Click",
    "Boost your brand": "Boost your brand",
    "Create campaigns on public roads in minutes and reach thousands of people": "Create campaigns out of home in minutes and reach thousands of people",
    "Strategically positioned where your ideal audience is.": "Strategically positioned where your ideal audience is.",
    "All you need to plan and manage Digital Out Of Home campaigns, in one place.": "All you need to plan and manage Digital Out Of Home campaigns, in one place.",
    "Get to know us": "Get to know us",
    "Discover the latest in outdoor advertising": "Discover the latest in outdoor advertising",
    "Communicate your brand to thousands of people intelligently": "Communicate your brand to thousands of people intelligently",
    "Without intermediaries": "Without intermediaries",
    "Without calls": "Without calls",
    "100% Online": "100% Online",
    "Do you have screens?": "Do you have screens?",
    "Join the largest network in America, manage your business and increase sales.": "Join the largest network in America, manage your business and increase sales.",
    "Register as media company": "Register",
    "I dont have CMS": "I don't have CMS",
    "I have CMS": "I have CMS",
    "Know the media details": "Know the details",
    "Audience measurement with artificial intelligence": "Audience measurement with artificial intelligence",
    "Our campaigns are based on traffic and people metrics. Find out how we do it.": "Our campaigns are based on traffic and people metrics. Find out how we do it.",
    "Know the audience details": "Know the details",
    "Partners": "Partners",
    "Blog": "Blog and News",
    "Text Blog 1": "Create campaigns in LatinAd for +150 DSPs",
    "Description Blog 1": "Launch DOOH campaigns by purchasing all available media in Latin America and accessing more than 150 DSPs.",
    "Text Blog 2": "Plan in Latinad and implement in external DSPs",
    "Description Blog 2": "We share the tutorial with you.",
    "Text Blog 3": "Visit our help site",
    "Description Blog 3": "Help will teach you about Latinad.",
    "Platform integrated to the DOOH and programmatic Ecosystem": "Platform integrated to the DOOH and programmatic Ecosystem",
    "You must be logged in to see the price": "You must be logged in to see the price",

    // Info
    // "Watch our video": "Watch our video",
    // "You are part of the OOH advertising world on. Learn here.": "You are part of the OOH advertising world on. Learn here.",
    // "3 Simple Steps to start your campaign": "3 Simple Steps to start your campaign",
    // "It is everything you need to launch your campaign on public roads": "Our platform offers everything you need to launch your Out of Home campaign",
    // "Do you have screens?": "Do you have screens?",
    // "Join the largest Out of Home network in America": "Join the largest Out of Home network in America",

    // Expansion
    "Where we are?": "Where we are?",
    "Argentina": "Argentina",
    "Peru": "Peru",
    "Ecuador": "Ecuador",
    "Colombia": "Colombia",
    "Central America": "Central America",
    "Chile": "Chile",
    "Mexico": "Mexico",
    "US": "United States",

    // UserSettingComponent
    "Account": "Account",
    "Agency": "Agency",
    "Profile information": "Profile information",
    "User": "User",
    "Email address": "Email address",
    "Profile photo": "Profile photo",
    "Change profile photo": "Change profile photo",
    "Only image files are allowed": "Only image files are allowed",
    "The image must be smaller than 2MB": "The image must be smaller than 2MB",
    "Could not update the profile photo": "Could not update the profile photo",
    "Agency data": "Agency data",
    "Business name": "Business name",
    "Tax ID": "Tax ID",
    "Associated brands": "Associated brands",
    "You have no associated clients yet": "You have no associated clients yet",
    "Mail": "Mail",
    "Change Mail": "Change Mail",
    "New Mail": "New Mail",
    "Change Password": "Change Password",
    "Current Password": "Current password",
    "New Password": "New Password",
    "Repeat New Password": "Repeat New Password",
    "Repeat the old password": "Repeat old password",

    // QuotesComponent
    "Quotes": "Proposal",
    "Sub type": "Sub type",
    "Not assigned": "Not assigned",
    "See quote": "See proposal",
    "Delete quote": "Delete proposal",
    "Unarchived quote": "Unarchived proposal",
    "Archived quote": "Archived proposal",
    "Quote removed successfully": "Proposal removed successfully",
    "Quote archived successfully": "Proposal archived successfully",
    "Quote unarchived successfully": "Proposal unarchived successfully",
    "An error occurred while trying to delete quote": "An error occurred while trying to delete proposal",
    "An error occurred while trying to update quote": "An error occurred while trying to update quote",
    "Quote updated successfully": "Quote updated successfully",
    "Minumum budget": "El presupuesto debe ser mayor a ",
    "Created": "Created",
    "Start": "Start",
    "StartSearch": "Start",
    "End": "End",
    "Qty. Screens": "Qty. Screens",
    "Action": "Action",

    // CampaignsComponent
    "Campaign successfully removed": "Campaign successfully removed",
    "You cannot delete campaigns with payments created": "You cannot delete campaigns with payments created",
    "No campaigns": "No campaigns",
    "No proposal has been generated": "No proposal has been generated",
    "There is no client": "There is no client",
    "There is no brand": "There is no brand",
    "An error occurred while deleting campaign": "An error occurred while deleting campaign",
    "Getting campaigns": "Getting campaigns",
    "You havent created your first campaign yet.": "You have not created your first campaign yet.",
    "Still to be paid": "Still to be paid",
    "Pending approval": "Pending approval",
    "Active": "Active",
    "Next": "Next",
    "Previous": "Finished",
    "Proposals": "Proposals",
    "Archived": "Archived",
    "Atention!": "Atention!",
    "You are about to delete a campaign. Are you agree?": "You are about to delete a campaign. Are you agree?",
    "You are about archived a {type}, then you can unarchived in seccion archived": "You are about archived a {type}, then you can unarchived in seccion archived",
    "You are about unarchive a {type}": "You are about unarchive a {type}",
    "OK": "Ok",
    "To modify this campaign, use the new version of the DSP with which it was created": "To modify this campaign, use the new version of the DSP with which it was created.",
    "New version": "New version",
    "Version": "Version",
    "Are you sure you want to delete this relationship?": "Are you sure you want to delete this relationship?",
    "Manage ads and screens": "Manage ads and screens",
    "Ad library": "Ad library",
    "My ads": "My ads",
    "Search ads": "Search ads",
    "Upload ad": "Upload ad",
    "New folder": "New folder",
    "No ads yet": "No ads yet",
    "Brands": "Brands",
    "Clients": "Clients",
    "No clients selected. Please select one": "No clients selected. Please select one",
    "No clients available": "No clients available",
    "No brands available": "No brands available",
    "Brand": "Brand",
    "Folder": "Folder",
    "Select a client and a brand to view their ads": "Select a client and a brand to view their ads",
    "Select a folder to view its ads": "Select a folder to view its ads",
    "All ads": "All ads",
    "Creation date": "Creation date",
    "Items": "Items",
    "Actions": "Actions",
    "Folders": "Folders",
    "Ads": "Ads",
    "Select folder": "Select folder",
    "Deselect folder": "Deselect folder",
    "Sort": "Sort",
    "Most recent": "Most recent",
    "Oldest": "Oldest",
    "Ad type": "Ad type",
    "Ad status": "Ad status",
    "Available": "Available",
    "In use": "In use",
    "items": "items",
    "Select a brand": "Select a brand",
    "Choose one of the folders above (for example, {{first}} or {{second}}) to view and manage its ads.": "Choose one of the folders above (for example, <strong>{{first}}</strong> or <strong>{{second}}</strong>) to view and manage its ads.",
    "Choose one of the folders above (for example, {{first}}) to view and manage its ads.": "Choose one of the folders above (for example, <strong>{{first}}</strong>) to view and manage its ads.",
    "Choose one of the folders above to view and manage its ads.": "Choose one of the folders above to view and manage its ads.",
    "Rename": "Rename",
    "ContentsTag errors.": "A folder with this name already exists.",
    "Rename ad": "Rename ad",
    "Rename folder": "Rename folder",
    "Create new folder": "Create new folder",
    "Folder name": "Folder name",
    "e.g. Summer Promo Banner": "e.g. Summer Promo Banner",
    "Create folder": "Create folder",
    "Upload new ad": "Upload new ad",
    "Upload file": "Upload file",
    "Upload {{count}} files": "Upload {{count}} files",
    "{{count}} files selected": "{{count}} files selected",
    "Click to upload or drag your files here": "Click to upload or drag your files here",
    "Supports JPG, PNG, MP4, MP3 (Max 500MB)": "Supports JPG, PNG, MP4, MP3 (Max 500MB)",
    "Drop files to upload": "Drop files to upload",
    "Uploading {{name}}…": "Uploading {{name}}…",
    "{{name}} uploaded": "{{name}} uploaded",
    "Could not upload {{name}}": "Could not upload {{name}}",
    "They will be saved in {{folder}}": "They will be saved in <strong>{{folder}}</strong>",
    "Brand / Folder": "Brand / Folder",
    "Archive folder": "Archive folder",
    "Are you sure you want to archive this folder?": "Are you sure you want to archive this folder?",
    "This tag already exist in this folder.": "A folder with this name already exists in this location.",
    "Archive ad": "Archive ad",
    "Are you sure you want to archive this ad? This action cannot be undone.": "Are you sure you want to archive this ad? This action cannot be undone.",
    "Archive {{count}} items": "Archive {{count}} items",
    "Archive items": "Archive items",
    "Are you sure you want to archive the {{count}} selected items? This action cannot be undone.": "Are you sure you want to archive the {{count}} selected items? This action cannot be undone.",
    "{{count}} selected": "{{count}} selected",
    "Clear selection": "Clear selection",
    "Campaign Ads": "Campaign Ads",
    "The ad will be detached from the group of screens of this resolution and will no longer be used in the campaign. You can add it again later.": "The ad will be detached from the group of screens of this resolution and will no longer be used in the campaign. You can add it again later.",
    "The ad will be unlinked from this screen. You can add it again later..": "The ad will be unlinked from this screen. You can add it again later..",
    "The ad will be unlinked from this group of screens. You can add it again later.": "The ad will be unlinked from this group of screens. You can add it again later.",
    "This ad is not linked to another screen, so it will no longer be used in the campaign.": "This ad is not linked to another screen, so it will no longer be used in the campaign.",
    "The ad will be unlinked from the group of screens for this resolution. Since it is not linked to any other screen, it will no longer be used in the campaign. You can add it again later.": "The ad will be unlinked from the group of screens for this resolution. Since it is not linked to any other screen, it will no longer be used in the campaign. You can add it again later.",
    "The ad will be unlinked from this screen. This ad is not linked to any other screen, so it will no longer be used in the campaign. You can add it again later.": "The ad will be unlinked from this screen. This ad is not linked to any other screen, so it will no longer be used in the campaign. You can add it again later.",
    "The ad will be unlinked from this group of screens. This ad is not linked to any other screen, so it will no longer be used in the campaign. You can add it again later.": "The ad will be unlinked from this group of screens. This ad is not linked to any other screen, so it will no longer be used in the campaign. You can add it again later.",
    "Are you sure you want to delete this ad from the library? You will need to upload it again if you want to use it again.": "Are you sure you want to delete this ad from the library? You will need to upload it again if you want to use it again.",

    // CampaignsCard
    "Ads rejected": "Ad(s) rejected(s)",
    "See detail": "See Detail",
    "Report": "Report",
    "View report": "See report",
    "Campaign created by": "Campaign created by",
    "the day": "The day",
    "at": "at",
    "for a total amount of": "For a total amount of",
    "Price breakdown": "Price breakdown",
    "Media investment": "Media investment",
    "LatinAd commission": "LatinAd commission",
    "Partner commission": "Partner commission",
    "DSP commission": "DSP commission",
    "Exchange commission": "Exchange commission",
    "Agency commission": "Agency commission",
    "Taxes": "Taxes",
    "National taxes": "National taxes",
    "International taxes": "International taxes",
    "Subtotal without taxes": "Subtotal without taxes",
    "Total with taxes": "Total with taxes",
    "Includes adjustment rate": "Includes adjustment rate",
    "This chart does not include taxes": "This chart does not include taxes",
    "Could not load the price breakdown": "Could not load the price breakdown",
    "Delete campaign": "Delete campaign",
    "Archive campaign": "Archive campaign",
    "Unarchive campaign": "Unarchive campaign",
    "Archive proposal": "Archive proposal",
    "Unarchive proposal": "Unarchive proposal",
    "Campaign created as Programmatic": "Campaign created as Programmatic",
    "Campaign created as Traditional": "Campaign created as Traditional",
    "Click for more information": "Click for more information",
    "Group screens": "Group screens",

    // CampaignsCardModal
    "See campaign": "See campaign",

    // Modal Replicate Campaign
    "Replicate campaign": "Replicate campaign",
    "Replicated": "Replicated",
    "The name is required": "The name is required",
    "A campaign with a pending payment status will be created, keeping the contents and screens that are still available for sale.": "A campaign with a pending payment status will be created, keeping the contents and screens that are still available for sale.",
    "The original campaign has rules based on dates, these will be removed. Remember to configure them again.": "The original campaign has rules based on dates, these will be removed. Remember to configure them again.",

    //Modal Edit Campaign Manager
    "Some ads do not match the screen resolutions": "Some ads do not match the screen resolutions",
    "in this group": "in this group",
    "on this display": "on this display",
    "The campaign allows a tolerance of": "The campaign allows a tolerance of",
    "%. If you want to increase it, you can adjust it from the previous step, in the Ads section.": "%. If you want to increase it, you can adjust it from the previous step, in the Ads section.",
    "This ad doesn't match any of the resolutions. Increase the campaign tolerance in the previous step and try again.": "This ad doesn't match any of the resolutions. Increase the campaign tolerance in the previous step and try again.",
    "Version already exists for this resolution": "Version already exists for this resolution",
    "Does not match any resolution, increase tolerance in the previous step.": "Does not match any resolution, increase tolerance in the previous step.",
    "Increase the campaign tolerance in the Ads section.": "Increase the campaign tolerance in the Ads section",
    "resolution.mismatch.single": "Some ads do not match the screen resolution. The campaign allows a tolerance of {{tolerance}}%. If you want to increase it, you can adjust it from the previous step, in the Ads section.",
    "resolution.mismatch.group": "Some ads do not match the screen resolutions in this group. The campaign allows a tolerance of {{tolerance}}%. If you want to increase it, you can adjust it from the previous step, in the Ads section.",

    // Under Minimum Spots Modal
    "Some screens do not meet the minimum investment": "Some screens do not meet the minimum investment",
    "Some screens do not meet the minimum daily investment": "Some screens do not meet the minimum daily investment",
    "Minimum investment": "Minimum investment",
    "Minimum investment/day": "Minimum investment/day",
    "Equivalent spots": "Equivalent playouts",
    "Equivalent impressions": "Equivalent impressions",
    "These screens will be rejected if the minimum investment is not increased": "These screens will be rejected if the minimum investment is not increased",
    "These screens will be rejected if the minimum daily investment is not increased": "These screens will be rejected if the minimum daily investment is not increased",
    "Adjust investment now": "Adjust investment now",
    "Ignore and continue": "Ignore and continue",
    "Current": "Current",
    "Need": "Need",
    "more": "more",

    // Modal Select Registration Type
    "Welcome to LatinAd": "Welcome to LatinAd",
    "Are you an agency?": "Are you an agency?",
    "Are you an advertiser?": "Are you an advertiser?",
    "Company name": "Company name",
    "State (optional)": "State (optional)",
    "User Email": "User Email",
    "First and last name": "First and last name",
    "Phone number": "Phone number",

    // CampaignsComponent
    "Screen resolution": "Screen resolution",
    "Announcement resolution": "Ad resolution",
    "Purchased impressions": "Purchased playouts",
    "Promised impressions": "Promised playouts:",

    "Screen details": "Screen details",
    "There was an error": "There was an error",
    "You do not have permissions to access this campaign": "You do not have permissions to access this campaign",
    "The requested campaign does not exist": "The requested campaign does not exist",
    "You must first delete the pending payment before retrying a new payment": "You must delete the pending payment before retrying a new payment",
    "Detail": "Detail",
    "Your Ads": "Your Ads",
    "Your payments": "Your payments",
    "No payment created": "No payment created",
    "Create new payment": "Create new payment",
    "Your ads for each screen": "Your ads for each screen",
    "See detailed report": "See detailed report",
    "The campaign will be paused, which means it will stop running and will not consume budget until it is reactivated.": "You are going to pause a campaign, so it will stop being displayed and will not consume budget until it is reactivated.",
    "The campaign will be activated, which means it will start running and begin consuming budget again until it is paused.": "The campaign will be activated, which means it will start running and begin consuming budget again until it is paused.",
    "Activate campaign": "Activate campaign",
    "Edit campaign": "Edit campaign",
    "Edit proposal": "Edit proposal",
    "View campaign in Campaign Manager": "View campaign in Campaign Manager",
    "Once you proceed to step 2, you won’t be able to change the creation type (campaign or proposal) without losing your settings.": "Once you proceed to step 2, you won’t be able to change the creation type (campaign or proposal) without losing your settings.",
    "The logged-in user is not the owner of this campaign": "The logged-in user is not the owner of this campaign, please switch companies to access the campaign",
    "Credit/debit card": "Credit/debit card",
    "MercadoPago": "MercadoPago",
    "Cash/Transfer": "Cash/Transfer",
    "Approved": "Approved",
    "Paused": "Paused",
    "Ready": "Active",
    "Pending": "Pending",
    "Finalized": "Finalized",
    "Processing": "Processing",
    "Cancelled": "Cancelled",
    "Cancelled by user": "Cancelled by user",
    "Refunded": "Refunded",
    "In dispute": "In dispute",
    "Voided by claim": "Voided by claim",
    "Spots pending approval of the owner of each screen": "Playouts pending approval of the publisher for each screen",
    "Approved by the owners of each screen": "Approved by the publishers of each screen",
    "Rejected": "Rejected",
    "To modify": "To modify",
    "Campaign pending approval status, check with your manager.": "Campaign is in approval pending status, check with your manager.",
    "Campaign in pending payment status.": "Campaign in pending payment status.",
    "Exit edit mode": "Exit edit mode",
    "Entering edit mode": "Entering edit mode",
    "When entering the edit mode of a ": "When entering the edit mode of a ",
    "some prices may be changed ": "some prices may be changed ",
    "(only in cases where screen owners have updated those prices), since this campaign does not have payments generated nor has it been launched, therefore that prices have not been frozen.": "(only in cases where publishers have updated those prices), since this campaign does not have payments generated nor has it been launched, therefore that prices have not been frozen.",
    "Entering campaign edit mode. This campaign has approved payment, so only elements that do not alter its price can be edited.": "Entering campaign edit mode. This campaign has approved payment, so only elements that do not alter its price can be edited.",
    "Go to edit": "Go to edit",
    "Proposal": "Proposal",
    "proposal": "Proposal",
    "Proposal updated": "Proposal updated",
    "This option allows you to edit the proposal without generating a payment or changing its status.": "This option allows you to edit the proposal without generating a payment or changing its status.",
    "Generate proposal": "Generate proposal",
    "Campaign details": "Campaign details",
    "Category": "Category",
    "Are you sure you want to actionText?": "Are you sure you want to actionText?",
    "All current progress will be lost": "All current progress will <strong>be lost</strong>",

    // CampaignTopbar
    "Exhibition date": "Exhibition date",
    "Duration": "Duration",
    "Real Impressions": "Real playouts",
    "Show map": "Show map",
    "Starts": "Beginning",
    "Today": "Today",
    "Finished": "Finished",
    "Campaign country": "Country",
    "Edit exhibition dates": "Edit exhibition dates",
    "Edit campaign dates warning title": "Do you want to modify the campaign date?",
    "Edit campaign dates warning": "When you do, <tag>all screens will be in pending state</tag> and will be activated as they are approved.",
    "minimum programmatic spots warning": "The minimum daily investment required for this screen is <strong>{{minimumInvestmentDaily}}</strong>.<br/>Please increase the budget to avoid the ad being rejected.",
    "minimum programmatic total investment warning": "The minimum total investment required for this screen is <strong>{{minimumInvestmentTotal}}</strong>.<br/>Please increase the budget to avoid the ad being rejected.",
    "minimum investment breakdown": "{{minimumInvestmentDaily}} daily corresponds to {{minimumInvestmentTotal}} in total",
    "New dates": "New dates",
    "Campaign dates updated successfully": "Campaign dates updated successfully",
    "There is a problem with the dates. Please check them and try again.": "There is a problem with the dates. Please check them and try again.",
    "It is necessary for the pending date changes to be approved in order to be able to edit again.": "It is necessary for the pending date changes to be approved in order to be able to edit again.",

    // PaymentStatusComponent
    "Cash": "Cash",
    "Check": "Bank Check",
    "Transfer": "Transfer",
    "Current account": "Credit account",
    "Direct credit": "Direct Credit",
    "Payment made through Mercado Pago with Card ending in": "Payment made through Mercado Pago with Card ending in",
    "Payment made by Mercado Pago": "Payment made by Mercado Pago",
    "Card": "Card",
    "finished in": "finished in",
    "Unknown payment method": "Unknown payment method",
    "Final consumer": "Final consumer",
    "Invoice": "Invoice",
    "Your payment has already been approved.": "Your payment has already been approved.",
    "The payment is pending accreditation.": "The payment is pending accreditation.",
    "The payment is pending payment.": "Payment is pending.",
    "Your payment has been credited successfully.": "Your payment has been credited successfully.",
    "The payment was canceled, you can generate another payment and choose the method you want.": "The payment was canceled, you can generate another payment and choose the method you want.",
    "We are processing your payment. In less than two business days we will notify you of the result.": "We are processing your payment. In less than two business days we will notify you of the result.",
    "Check the card number.": "Check the card number.",
    "Please review the data and try again.": "Please review the data and try again.",
    "Check the security code.": "Check the security code.",
    "We were unable to process your payment. Please try another payment method.": "We were unable to process your payment. Please try another payment method.",
    "Please call your card to authorize the payment and try again.": "Please call your card to authorize the payment and try again.",
    "Your card is not active. Please call the phone number on the back of your card.": "Your card is not active. Please call the phone number on the back of your card.",
    "You already made a payment for that value. If you need to pay again, use another card or another means of payment.": "You already made a payment for that value. If you need to pay again, use another card or another payment method.",
    "Your payment was declined. Choose another of the means of payment, we recommend using cash.": "Your payment was declined. Choose another payment method, we recommend using cash.",
    "Your card does not have sufficient funds to carry out the operation.": "Tu tarjeta no tiene fondos suficientes para realizar la operación.",
    "Your card cannot process installment payments.": "Your card cannot process installment payments.",
    "You have reached the limit of allowed attempts. Choose another card or other means of payment.": "You have reached the limit of allowed attempts. Choose another card or another payment method.",
    "Start date": "Starting date",
    "Finish date": "Final date",
    "Total campaign price": "Total campaign price",
    "Successful payment": "Successful payment",
    "Pending payment": "Pending payment",
    "Payment canceled": "Payment canceled",
    "Payment declined": "Payment declined",
    "Payment": "Payment",
    "Total without tax": "Total without tax",
    "Total with tax": "Total with tax",
    "tax included": "tax included",
    "more taxation": "+ tax",
    "+tax": "+tax",
    "Billing information": "Billing information",
    "If you want to pay with another means of payment, you can return to the list of payments in your campaign, delete the pending payment, and make a new payment.": "If you want to pay with another payment method, you can return to the list of payments in your campaign, delete the pending payment, and make a new payment.",
    "Go to my campaign": "Go to my campaign",
    "Summary": "Summary",
    "See spot": "See ad",
    "Discount": "Discount",
    "Your ads have been sent to the owners of each screen for their review and approval. This process can take up to 48 hours. We will send you a notification by mail when this process is complete.": "Your ads have been sent to the publishers of each screen for their review and approval. This process can take up to 48 hours. We will send you a notification by mail when this process is complete.",
    "rejected": "Rechazado",
    "View purchase order": "View purchase order",
    "Upload ODC": "Upload PO",
    "Date expiry": "Date expiry",
    "Name as it appears on the card": "Name as it appears on the card",
    "Campaign name placeholder": "Enter a distinctive name to identify it",

    // AdScreenCard
    "This would modify the value of the campaign, create a new campaign or contact support": "This would modify the value of the campaign, create a new campaign or contact support",
    "The file cannot be larger than 50MB!": "The file cannot be larger than 50MB!",
    "successfully uploaded": "successfully uploaded",
    "You cannot upload files longer than those allowed by the programmatic": "You cannot upload files longer than those allowed by the programmatic",
    "You cannot upload files longer than what is allowed on the screen": "You cannot upload files longer than what is allowed on the screen",
    "Upload error": "Upload error",
    "Spot Approved": "Approved",
    "Spot Rejected": "Rejected",
    "Display out of service": "Display out of service",
    "There is already an active date-change request for this campaign.": "There is already an active date-change request for this campaign.",
    "Change of dates not approved": "Change of dates not approved",
    "Inactive": "Inactive",
    "Real time impressions": "Real time playouts",
    "The owner of this screen has not yet approved": "The publisher of this screen has not yet approved",

    "View screen details": "View screen details",
    "Screen Format": "Screen Format",
    "Price": "Price range",
    "Subsidized": "Subsidized",
    "Subsidize ad tooltip": "This ad's effective CPM will be subsidized",
    "Subsidize display tooltip": "The screen CPM will be subsidized",
    "Subsidize display traditional tooltip": "The screen's cost per day will be subsidized",
    "Pre approved": "Pre approved",
    "Coming soon": "Coming soon",
    "Total subsidize": "Total subsidize",
    "subsidized": "subsidized",
    "Suspended": "Suspended",
    "It will be in suspended state if the value is 0.": "It will be in suspended state if the value is 0.",
    "Campaign subsidized": "Subsidized",
    "Subsidize impression": "Subsidized playouts",
    "Remaining subsidized spots": "Remaining subsidized playouts",
    "Subsidized impressions": "Subsidized impressions",
    "Remaining subsidized impressions": "Remaining subsidized imp.",
    "impressions subsidized/day": "subsidized imp. / day",
    "These impressions are reflected as subsidize in the campaign": "These impressions are reflected as subsidize in the campaign",
    "Preview": "Preview",
    "Preview not available": "Preview not available",
    "Change this ad for another, requires approval. Remember to upload ads of the same client, brand, campaign and similar duration.": "Change this ad for another, requires approval. Remember to upload ads of the same client, brand, campaign and similar duration.",
    "Change this ad for another, requires approval. Remember to upload ads of the same client, brand, campaign and similar duration. No immediately": "Change this ad for another, requires approval. Remember to upload ads of the same client, brand, campaign and similar duration. This action will be effective in up to 2 hours after approval",
    "Change ad": "Change ad",
    "This action will change the ad. It does require a new approval in the event that the previous ad has already been approved. Remember to upload a similar ad, from the same campaign, client and brand.": "This action will change the ad. It does require a new approval in the event that the previous ad has already been approved. Remember to upload a similar ad, from the same campaign, client and brand.",
    "Camera to traffic": "Camera to traffic",
    "View live traffic": "View live traffic",
    "Traffic camera for audience control and measurement": "Traffic camera for audience control and measurement",
    "You have not configured a camera pointing at traffic": "You have not configured a camera pointing at traffic",
    "Camera for certification": "Camera for certification",
    "No data": "No data",
    "Traffic today": "Traffic today",
    "Real-time vehicular traffic count": "Real-time vehicular traffic count",
    "Traffic this week vs previous week": "Traffic this week vs previous week",
    "Weekly count by type": "Weekly count by type",
    "Movement per hour in the week": "Movement per hour in the week",
    "View live screen": "View live screen",
    "Camera looking at screen for certification": "Camera looking at screen for certification",
    "You have not configured camera pointing at the screen": "You have not configured camera pointing at the screen",
    "See evidence": "See evidence",
    "Evidence": "Evidence",
    "M": "M",
    "T": "T",
    "W": "W",
    "TH": "T",
    "F": "F",
    "SA": "S",
    "SU": "S",
    "Every day": "Every day",
    "All day": "All day",
    "Rule": "Rule",

    // CartComponent
    "Quote created successfully": "Proposal created successfully",
    "An error occurred while trying to create a quote": "An error occurred while trying to create a proposal",
    "Screen selection": "Screen selection",
    "to the selection": "to the selection",
    "Estimated campaign budget": "Estimated campaign budget",
    "In the next step you will be able to configure the impressions per screen and you will see how the budget varies according to the impact you want.": "In the next step you will be able to configure the playouts per screen and you will see how the budget varies according to the impact you want.",
    "You must select a customer and brand before starting a campaign launch": "You must select a customer and brand before starting a campaign launch",
    "You must select a customer and brand before creating a quote": "You must select a customer and brand before creating a proposal",
    "CREATE PROPOSAL": "CREATE PROPOSAL",
    "SAVE PROPOSAL": "SAVE PROPOSAL",
    "EXPORT EXCEL": "Export Excel",
    "EXPORT MAP": "Export Map",
    "There are no more screens selected": "There are no more screens selected",
    "There are no screens here": "There are no screens here",
    "screens selected": "screens selected",
    "Reach": "Reach",
    "Impacts": "Impressions",
    "Circuits": "Circuits",
    "Imp./day": "Imp./day",
    "Faces": "Faces",
    "Total faces": "Total faces",
    "Faces of multiple-face screens": "Faces of multiple-face screens",
    "Faces of the screens within circuits": "Faces of the screens within circuits",
    "Estimated budget": "Estimated budget",
    "Save quote": "Save quote",
    "Export Excel": "Export Excel",
    "Export map": "Export map",
    "Delete selection": "Delete selection",
    "Empty cart": "Empty cart",
    "Delete screens": "Delete screens",
    "There are no more screens in the cart": "There are no more screens in the cart",
    "Create Quote": "Create Proposal",
    "Save Quote": "Save Quote",
    "The list of selected screens will be saved. You will be able to resume the campaign later from the My Quotes section.": "The list of selected screens will be saved. You will be able to resume the campaign later from the My Quotes section.",
    "Ads cannot be edited in approved campaigns": "Ads cannot be edited in approved campaigns",
    "To remove this screen, advance to the next step and transfer its outputs to another screen.": "To remove this screen, advance to the next step and transfer its outputs to another screen.",
    "New screen": "New screen",
    "New screen in this group": "New screen in this group",
    "New screens": "New screens",
    "There are new screens, transfer the budget accordingly.": "There are new screens, transfer the budget accordingly.",
    "Understood": "Understood",
    "Editing the campaign": "Editing campaign",
    "Exit edit": "Exit edit",
    "When you exit edit mode, any changes made to screens and settings will be lost.": "When you exit edit mode, any changes made to screens and settings will be lost.",
    "Slot duration": "Slot duration",
    "The minimum purchase price is not reached": "The minimum purchase price is not reached",
    "The minimum purchase price is": "The minimum purchase price is",
    "Currency exchange rate": "Currency exchange rate",
    "See currency exchange rate": "See exchange rate",
    "Conversion generated at 11AM (Argentina time) today": "Conversion generated at 11AM (Argentina time) today",
    "individual screen": "Individual screen",
    "individual screens": "Individual screens",
    "circuit added": "Circuit added",
    "circuits added": "Circuits added",
    "multiple face screen": "Multiple face screen",
    "multiple face screens": "Multiple face screens",
    "in total": "in total",
    // CheckoutDetails
    "Total cost": "Total",
    "Subtotal cost": "Subtotal",
    "Suggested price in local currency": "Suggested price in local currency",
    "It is the price that you should use when implementing the campaign in the chosen DSP, only if you want to do it in local currency.": "It is the price that you should use when implementing the campaign in the chosen DSP, only if you want to do it in local currency.",
    "Tax details": "Tax included",
    "Finish": "Finish",
    "Finish process for subsequent approval": "Finish process for subsequent approval",
    "By selecting this option, a payment will be generated and the proposal will be converted into a campaign.": "By selecting this option, a payment will be generated and the proposal will be converted into a campaign.",
    "View campaign": "View campaign",
    "Go Mercado Pago": "Go to Mercado Pago",
    "Apply discount coupon": "Apply discount coupon",
    "Coupon code": "Coupon code",
    "Remove discount": "Remove discount",

    // FiltersComponent
    "Client and brand": "Client / Brand",
    "Change campaign dates": "Change campaign dates",
    "Price per day per screen": "Price per day per screen",
    "Impressions per day per screen": "Playouts per day per screen",
    "Impressions": "Playouts",
    "Remaining spots": "Remaining playouts",
    "Remaining impressions": "Remaining imp.",
    "Impressions bought": "Impressions",
    "Modify impressions": "Modify impressions",
    "Modify impressions warning": "Modifying this value will update the ad's <b>playouts</b> and <b>investment</b>.",
    "Modify impressions warning_cpmi": "Modifying this value will update the ad's <b>investment</b>.",
    "Modify playouts": "Modify playouts",
    "Modify playouts warning": "Modifying this value will update the ad's <b>impressions</b> and <b>investment</b>.",
    "Modify subsidized impressions": "Modify subsidized impressions",
    "Modify subsidized impressions warning": "Modifying this value will update the ad's <b>playouts</b> and <b>investment</b>. It will also affect the <b>effective CPM</b>.",
    "Modify subsidized impressions warning_cpmi": "Modifying this value will update the ad's <b>investment</b>. It will also affect the <b>effective CPM</b>.",
    "Modify subsidized playouts": "Modify subsidized playouts",
    "Modify subsidized playouts warning": "Modifying this value will update the ad's <b>impressions</b> and <b>investment</b>. It will also affect the <b>effective CPM</b>.",
    "Effective CPM": "Effective CPM",
    "Screen CPM": "Screen CPM",
    "All": "All",
    "Outdoor": "Outdoor",
    "Indoor": "Indoor",
    "Mobile": "Mobile",
    "Point of sale": "Point of sale",
    "Region": "Region",
    "Format": "Format",
    "Search by city, place,region...": "Search by city, place, region...",
    "Big": "Big",
    "Other Filters": "Other Filters",
    "Show and edit filters": "Show and edit filters",
    "circuit": "Circuit",

    // ScreenCardComponent
    "Real-time audience": "Real-time audience",
    "Audience detail": "Audience detail",
    "Non-automated screen. Click to see detail": "Non-automated screen. Click to see detail",
    "Non-automated screen": "Non-automated screen",
    "The screens of this circuit are synchronized": "The screens of this circuit are synchronized",
    "This screen does not have the real-time print notice. Therefore, print reports may take up to 48 hours to be reflected.": "This screen does not have the real-time print notice. So the playouts reports can take up to be reflected, and they can be out of date in time.",
    "Screen belonging to the circuit": "Screen belonging to the circuit",
    "of count_secondary_displays screens": "of count_secondary_displays screens.",
    "It is not possible to purchase these screens individually.": "It is not possible to purchase these screens individually.",
    "sync": "sync",
    "spots/day": "playouts / day",
    "spots subsidized/day": "subsidized playouts / day",
    "impressions/day": "imp. / day",
    "Audience Average": "Audience Average",
    "Average audience of your screen": "Average audience of your screen(s)",
    "Audience by day of the week": "Average audience by day of the week",
    "Audience by time of day": "Average audience by hour of the day",
    "Monday": "Monday",
    "Tuesday": "Tuesday",
    "Wednesday": "Wednesday",
    "Thursday": "Thursday",
    "Friday": "Friday",
    "Saturday": "Saturday",
    "Sunday": "Sunday",
    "Average audience of your screen by day of the week": "Average audience of your screen(s) by day of the week",
    "Average audience per hour in the day": "Average audience per hour in the day",
    "Select days of the week": "Select days of the week",
    "Filter audience by day of the week": "Filter audience by day of the week",
    "Filter": "Filter",
    "Average audience by date": "Average audience by date",
    "Select hours of the day": "Select hours of the day",
    "Filter audience by day of the week or hour": "Filter audience by day of the week or hour",
    "Total number of people impacted": "Total number of people impacted",
    "Day of greatest impact": "Day of greatest impact",
    "Biggest Impact/Day": "Biggest Impact/Day",
    "Hour with the greatest impact": "Hour with the greatest impact",
    "Biggest Impact/Hour": "Biggest Impact/Hour",
    "Sum of Impressions per day (Dates)": "Sum of Impressions per day (Dates)",
    "Average Impressions per Hour (Dates)": "Average Impressions per Hour (Dates)",
    "Comparison by Screen": "Comparison by Screen",
    "Sum of Impressions per day": "Sum of Impressions per day",
    "The circuit has": "The circuit has",
    "has multiple faces": "has multiple faces",
    "have multiple faces": "have multiple faces",
    "face": "face",
    "faces": "faces",
    "screens_abbreviated": "screens",
    // RequestSpecialCpmComponent - RequestSpecialPriceComponent
    "Agreed prices": "Agreed prices",
    "Send request": "Send request",
    "You can request the agreed price to the media company by entering the agreed amount below. When you send it, the media company will receive an email with the request and LatinAd will notify you when the set price is reached to continue with your purchase.": "You can request the agreed price to the publisher by entering the agreed amount below. When you send it, the publisher will receive an email with the request and LatinAd will notify you when the set price is reached to continue with your purchase.",
    "You can request the agreed price to the media company by entering the agreed amount below. When you send it, the media company will receive an email with the request and the system will notify you when the set price is reached to continue with your purchase.": "You can request the agreed price to the publisher by entering the agreed amount below. When you send it, the publisher will receive an email with the request and the system will notify you when the set price is reached to continue with your purchase.",
    "The original price is": "The original price is",
    "per CPM.": "per CPM.",
    "per day.": "per day.",
    "Agreed price": "Agreed price",
    "Final prices may contain platform commissions and may vary depending on the selected client": "Final prices may contain platform commissions and may vary depending on the selected client",
    "Request agreed price": "Request agreed price",
    "The agreed price must be greater than 0": "The agreed price must be greater than 0",
    "The agreed price must be less than the original price": "The agreed price must be less than the original price",
    "There is already a cpm price arrangement request for this display": "There is already a cpm price arrangement request for this display",
    "There is already a cpm price arrangement for this display": "There is already a cpm price arrangement for this display",
    "There is already a price arrangement request for this display": "There is already a price arrangement request for this display",
    "There is already a price arrangement for this display": "There is already a price arrangement for this display",
    "Request sent successfully": "Request sent successfully",
    "To keep in mind": "To keep in mind",
    "The agreed-upon price does not include local or international taxes.": "The agreed-upon price does not include local or international taxes.",
    "Final prices may include platform fees and may vary depending on the selected client.": "Final prices may include platform fees and may vary depending on the selected client.",
    "In the event that the screen price is in a different currency than the one being used for the purchase, final prices may vary due to conversion.": "In the event that the screen price is in a different currency than the one being used for the purchase, final prices may vary due to conversion.",
    "You already have an agreed price": "You already have an agreed price",

    // CardComponent
    "screens that you added to the selection have cameras measuring audience. You can go to the detail of each one to analyze the data and optimize your campaign": "screens that you added to the selection have cameras measuring audience. You can go to the detail of each one to analyze the data and optimize your campaign",
    "Screens measuring audience": "Screens measuring audience",
    "Total screens added in the campaign": "Total screens added in the campaign",
    "Estimated impressions based on campaign settings. You can add campaign days (in traditional) or increase the budget (in programmatic).": "Number of people who will see your ad or group of ads based on campaing settings.",
    "See audience details": "See estimate audience details",
    "See audience button": "See",
    "Max. available imp.": "Max. available imp.",
    "Max. avail. imp.": "Max. avail. imp.",
    "Max. available impressions": "Max. available impressions",
    "Value based on screen occupancy statistics, so it can vary daily.": "Number of people who will see your ad or group of ads based on campaing settings.",
    "(CPM) cost per thousand impression": "Cost to reach a thousand people, averaged and weighted by the investment on each screen across the whole campaign",
    "(CPM) cost per thousand impression by group": "Cost to reach a thousand people, averaged and weighted by the investment on each screen across the whole group",
    "CPM Average": "CPM Average",
    "Original CPM": "Original CPM",
    "Final CPM": "Final CPM",
    "audience impressions": "Impressions",
    "Audience impressions": "Impressions",
    "delivered spots": "Playouts",
    "estimated playouts qualifier": "Estimated",
    "projected playouts qualifier": "Projected",
    "minimum playouts qualifier": "Minimum",
    "playouts label": "{{qualifier}} playouts",
    "playouts remaining label": "{{qualifier}} playouts remaining",
    "subsidized playouts label": "{{qualifier}} subsidized playouts",
    "playouts per day label": "{{qualifier}} playouts / day",
    "Upload material": "Upload material",
    "Versions": "Versions",
    "Selected ads": "Selected ads",
    "Used ads": "Used ads",
    "Estimated impressions based on campaign settings. You can add campaign days( in traditional) or increase the budget (in programmatic).": "Estimated impressions based on campaign settings. You can add campaign days( in traditional) or increase the budget (in programmatic).",
    "Ad state": "Ad state",
    "Ad information": "Ad information",
    "On hold": "On hold",
    "This group includes ads with the following status. Expand the group to view them.": "This group includes ads with the following status. Expand the group to view them.",

    // CheckoutStepsComponent
    "Campaign budget": "Campaign budget",
    "You can configure the impressions per screen and see how the updated budget varies according to the impact you want.": "You can configure the playouts per screen and see how the updated budget varies according to the impact you want.",

    // StepsComponent
    "Select screens": "Select screens",
    "Upload your spots": "Upload your ads",
    "Launch your campaign": "Launch your campaign",

    //Contents of campaign
    "Required resolutions": "Required resolutions",
    "Required resolution": "Required resolution",
    "Tolerance": "Tolerance",
    "Clear progress": "Clear progress",
    "Clear all contents added to the campaign, clearing its progress": "Clear all contents added to the campaign, clearing its progress",
    "Info tolerance": "By increasing the tolerance, it will allow ads to be displayed on screens that do not match the exact resolution (you can then choose to show black spaces or stretch the ad).",
    "for the screen": "For the screen",
    "for these versions": "for these versions",
    "for screens grouped as": "For screens grouped as",
    "To replace this content": "To replace this ad",

    // VideoUploadComponent
    "the file is not ready yet": "the file is not ready yet",
    "upload a file for the campaign": "upload a file for the campaign",
    "Campaign successfully created": "Campaign successfully created",
    "Proposal successfully created": "Proposal successfully created",
    "You can see it in the My campaigns section.": "You can see it in the My Campaigns Section",
    "You have not selected screens, you can go back to the map and do it from there.": "You have not selected screens, you can go back to the map and do it from there.",
    "Your campaign": "Your campaign",
    "Your proposal": "Your proposal",
    "Contents library": "Ads library",
    "Content added in campaign list": "Content added in campaign list",
    "Added": "Added",
    "You must select a content": "Select ads in the section above",
    "Aspect": "Aspect",
    "General dimensions": "General dimensions",
    "Dimensions": "Dimensions",
    "Type of screen": "Type of screen",
    "Ubication": "Ubication",
    "Group by": "Group by",
    "Output settings": "Output settings",
    "Frequency settings": "Frequency settings",
    "Organize screens": "Organize screens",
    "Assign": "Assign",
    "Confirm assign spots": "Confirm assign playouts",
    "You're about to assign the spots across all screens, which will modify any previous spot distribution. Do you wish to continue?": "You're about to assign the playouts across all screens, which will modify any previous playout distribution. Do you wish to continue?",
    "Confirm assign playouts title": "Confirm frequency change",
    "Confirm assign playouts body": "You're about to assign {{qualifier}} playouts evenly across every creative, which will change the total budget and any previous distribution of investment and impressions. Do you wish to continue?",
    "Balance spots": "Balance playouts",
    "You're about to balance the spots across all screens, which will modify any previous spot distribution. Do you wish to continue?": "You're about to balance the playouts across all screens, which will modify any previous playout distribution. Do you wish to continue?",
    "Contents for the campaign": "Group screens by",
    "Give your campaign a name so you can identify it": "Give your campaign a name so you can identify it",
    "Selection card title": "What are you going to do today?",
    "Create campaign step title": "Create campaign",
    "Create campaign step description": "Plan a full campaign with ads, playouts, and publication dates.",
    "Create campaign step description_cpmi": "Plan a full campaign with ads, impressions, and publication dates.",
    "Create proposal": "Create proposal",
    "Make a proposal step title": "Make a proposal",
    "Make a proposal step description": "Create a proposal with reach and budget to send to a client for a quote.",
    "Add more information if you need it": "Add more information if you need it",
    "Campaign objective": "Campaign objective",
    "Objetive": "Objetive",
    "You reached the character limit!": "You reached the character limit!",
    "Campaign name": "Campaign name",
    "Campaign extra information": "Campaign extra information",
    "Briefly describe the purpose and goals of your campaign.": "Briefly describe the purpose and goals of your campaign.",
    "Is it a test campaign?": "Is it a test campaign?",
    "Pause display": "Pause display",
    "You have already uploaded your ad! If you want to change it for all screens, click below": "You have already uploaded your ad! If you want to change it for all screens, click below",
    "Change spot material": "Change ad material",
    "general rule": "general rule",
    "General Rule (will apply to all screens)": "General Rule (will apply to all screens)",
    "Delete ad": "Delete ad",
    "Clear campaign progress in progress": "Clear campaign progress in progress",
    "Yes, clean": "Yes, clean",
    "All the progress you have made so far in this campaign will be cleaned up, such as the campaign name, the ads for each screen, and the settings.": "All the progress you have made so far in this campaign will be cleaned up, such as the campaign name, the ads for each screen, and the settings.",
    "Upload your ad": "Upload your ad",
    "Upload your ad (an image or a video), to preview how it will look on each of the screens you chose.": "Upload your ad (an image or a video), to preview how it will look on each screen you have chosen.",
    "Drag the ad here or": "Drag the ad here or",
    "click to load it.": "click to load it.",
    "Dont have the ad?": "Don't have the ad?",
    "Contact us and we will advise you.": "Contact us and we will advise you.",
    "Url whatsapp, Contact us": "https://api.whatsapp.com/send?phone=5492615019508&text=Hello,%20I%20would%20like%20to%20advertise%20but%20I%20still%20do%20not%20have%20the%20graphic%20piece.",
    "The time indicated by each screen will be displayed.": "The time indicated by each screen will be displayed.",
    "You can change the ad for each of the selected screens. Keep in mind that if it is an image, the ad will display the space time indicated by each screen. For videos, it will be the time of the video.": "You can change the ad for each of the selected screens. Keep in mind that if it is an image, the ad will display the space time indicated by each screen. For videos, it will be the time of the video.",
    "Selected screens": "Selected screens",
    "Updated budget": "Updated budget",
    "Tight budget": "Tight budget",
    "Balance $": "Balance $",
    "Redistribute": "Redistribute",
    "Total spots": "Projected playouts",
    "You can configure the spots per screen and see how the adjusted budget varies depending on the impact you want.": "You can configure the playouts per screen and see how the adjusted budget varies depending on the impact you want.",
    "You can configure the spots per screen and see how the adjusted budget varies depending on the impact you want._cpmi": "You can configure the impressions per screen and see how the adjusted budget varies depending on the impact you want.",
    "Upload your main ad to see how it will look on each screen": "Upload your main ad to see how it will look on each screen",
    "Your video of": "Your video of",
    "secs exceeds the playing time accepted by some selected screens. You can change the ad for a shorter one, or you can leave it and pay the proportional value for the time exceeded.": "secs exceeds the playing time accepted by some selected screens. You can change the ad for a shorter one, or you can leave it and pay the proportional value for the seconds exceeded.",
    "secs exceeds the standard time for programmatic campaigns of 10 seconds. You can change the ad for a shorter time.": "secs exceeds the standard time for programmatic campaigns of 10 seconds. You can change the ad for a shorter time.",
    "Your ad is": "Your ad is",
    "an image": "an image",
    "a video": "a video",
    "Printed so far": "Printed so far",
    "It has a duration of": "It has a duration of",
    "secs, and this time will be displayed": "secs, and this time will be displayed",
    "Campaign successfully edited": "Campaign successfully edited",
    "You can review it from this section before generating a payment.": "You can review it from this section before generating a payment.",
    "You can exit edit mode to create a new campaign.": "You can exit edit mode to create a new campaign.",
    "You are in campaign edit mode": "You are in campaign edit mode",
    "Exit": "Exit",
    "Go back to the original budget and recalculate impressions (changes you have made in impressions for each Spot will be erased)": "Go back to the original budget and recalculate playouts (changes you have made in playouts for each ad will be erased)",
    "Go back to the original budget (n_amountBudget) and recalculate impressions (changes you have made in impressions for each Spot will be erased)": "Go back to the original budget (n_amountBudget) and recalculate playouts (changes you have made in playouts for each ad will be erased)",
    "Redistribute the new budget and recalculate spots (changes made to spots for each ad will be deleted)": "Redistribute the new budget and recalculate playouts (changes made to playouts for each ad will be deleted)",
    "For each screen it will equalize the investment and recalculate the spots (changes you have made to spots for each ad or screen will be erased)": "For each screen it will equalize the investment and recalculate the playouts (changes you have made to playouts for each ad or screen will be erased)",
    "For each screen it will equalize the investment and recalculate the spots (changes you have made to spots for each ad or screen will be erased)_cpmi": "For each screen it will equalize the investment and recalculate the impressions (changes you have made to impressions for each ad or screen will be erased)",
    "The initial amount was modified; you can redistribute the budget": "The initial amount was modified; you can redistribute the budget",
    "Increase prints to fill all remaining": "Increase prints to fill all remaining",
    "Design and change spot": "Design and change ad",
    "Design spot": "Design ad",
    "What resolution will your main Spot have?": "What resolution will your main ad have?",
    "Width (px)": "Width (px)",
    "Height (px)": "Height (px)",
    "You will need to create an account and log in the first time you want to create a design.": "You will need to create an account and log in the first time you want to create a design.",
    "Identify your ad...": "Identify your ad...",
    "Contents": "Contents",
    "Configuration": "Configuration",
    "Make payment": "Make payment",
    "View contents from the folder": "Announcement folder",
    "Upload": "Select",
    "Upload continue": "or drag",
    "Upload continue 2": "ads here",
    "Upload message 1": "Select a",
    "Upload message 2": "folder to",
    "Upload message 3": "upload ads",
    "Folder advertisement": "A folder is a container of ads grouped by brands. To create new folders you must create new brands within clients in the CMS. Click on the <icon/> to learn how to do it.",
    "Version explain": "Before selecting ads for your campaign, you can categorize them by the appropriate version. For example: Version 1 = Breakfast, Version 2 = Mid-afternoon. Click on the <icon/> to learn how to do it.",
    "Select a person": "Select a person",
    "There are ads that do not adapt correctly to the resolutions. You can continue or select ads from closer resolutions.": "There are ads that do not adapt correctly to the resolutions. You can continue or select ads from closer resolutions.",
    "I don’t have my ads": "I don't have my ads",
    "I don’t have my ads tooltip": "If you don’t have the ads for your campaign yet, click on the <icon/> to learn how to proceed without them.",


    //ContentsLibraryComponent
    "Library of contents": "Library of contents",
    "Choose the version before choosing content": "Choose the version before choosing content",
    "Remove ad from the library": "Remove ad from the library",
    "Add content to the campaign": "Add content to the campaign",
    "This ad does not fit the screen resolution according to the tolerance set in the campaign": "This ad does not fit the screen resolution according to the tolerance set in the campaign",
    "Remove ads from the campaign": "Remove ads from the campaign",
    "Stop using this ad for the campaign.": "Stop using this ad for the campaign.",
    "Copy the name of this ad to all ads in the same version.": "Copy the name of this ad to all ads in the same version.",
    "You are about to clone this ad name to all other ads in the same version. This action will overwrite the current names.": "You are about to clone this ad name to all other ads in the same version. This action will overwrite the current names.",
    "Apply ad to available resolutions": "Apply ad to available resolutions",
    "Remove relation between content and displays": "Remove relation between content and displays",
    "Unlink ad from this screen group.": "Unlink ad from this screen group.",
    "It's the last relation on a screen, to delete it, its contents should be reorganized": "It's the last relation on a screen, to delete it, its contents should be reorganized",
    "This version cannot be deleted: at least one screen would be left without any ad.": "This version cannot be deleted: at least one screen would be left without any ad.",
    "It's the last ad on screen {{screenName}}; to delete it, first add another ad there": "It's the last ad on screen {{screenName}}; to delete it, first add another ad there",
    "Are you sure you want to remove this content from the campaign": "Are you sure you want to remove this content from the campaign?",
    "version": "Version",
    "Version of the ad": "Version of the ad",
    "Remplace": "Remplace",
    "Remplace version": "Remplace version",
    "Apply rule by versions": "Apply rule by versions",
    "Create another version": "Create another version",
    "A version with that resolution already exists, you want to replace the content": "A version with that resolution already exists, you want to replace the content",
    "A version with that resolution already exists on another screen, a new version will be created to avoid replacing the one currently in use.": "A version with that resolution already exists on another screen, a new version will be created to avoid replacing the one currently in use.",
    "Select a folder": "Select a folder",
    "This folder is not modified": "This folder is not modified",
    "Content information": "Content information",
    "Displays added in this relation ": "Displays added in this relation",
    "Hours": "Hours",
    "my_content": "My ads",
    "default": "Default",

    "REQUIRED": "REQUIRED",
    "Inactive version": "Inactive",
    "This version has ads that do not match any screen; they will not be saved.": "This version has ads that do not match any screen; they will not be saved.",
    "This ad does not match any screen and will not be saved": "This ad does not match any screen and will not be saved",
    "There are ads that do not match any screen and will not be saved ({{versions}}). Continue?": "There are ads that do not match any screen and will not be saved ({{versions}}). Continue?",
    "This version will be deactivated. Its remaining outputs will be redistributed equitably among the other active versions; outputs already delivered are preserved.": "This version will be deactivated. Its remaining outputs will be redistributed equitably among the other active versions; outputs already delivered are preserved.",
    "Version deactivated. Its remaining outputs were redistributed among the other active versions.": "Version deactivated. Its remaining outputs were redistributed among the other active versions.",
    "Ad successfully updated.": "Ad successfully updated.",
    "A version with that name already exists.": "A version with that name already exists.",
    "Names like V1, V2... are reserved for automatic versions and can't be used to rename.": "Names like V1, V2... are reserved for automatic versions and can't be used to rename.",
    "This version is inactive; its remaining outputs were redistributed.": "This version is inactive; its remaining outputs were redistributed.",
    "Ads in {{version}}": "Ads in {{version}}",
    "Version name": "Version name",
    "Ads for the campaign": "Ads for the campaign",
    "Create general rule": "Create general rule",
    "Pending resolutions": "Pending",
    "Covered resolutions": "Assigned",
    "Search resolution": "Search resolution",
    "Unassigned": "Unassigned",
    "Go to {{version}}": "Go to {{version}}",
    "Display": "Display",
    "total screens": "total screens",
    "pending resolutions": "pending",
    "All assigned": "All assigned",
    "Add to version": "Add to version",
    "Drag to add to version": "Drag to add to version",
    "Drag the ads you want to add to the campaign here, or add them from the ads list": "Drag the ads you want to add to the campaign here, or add them from the ads list",
    "Rename version": "Rename version",
    "Delete version": "Delete version",
    "Add version": "Add version",
    "Date": "Date",
    "Folder management is available in the Ad Library.": "Folder management is available in the Ad Library.",
    "This ad will be unlinked from the group of screens for this resolution.": "This ad will be unlinked from the group of screens for this resolution.",
    "Unlink this ad from these screens": "Unlink this ad from these screens",
    "Unlinked: {{name}}": "Unlinked: {{name}}",
    "This ad was unlinked from these screens": "This ad was unlinked from these screens",
    "Relink this ad to these screens": "Relink this ad to these screens",
    "Not available": "Not available",

    // ModalContent
    "Content data": "Content data",
    "Tolerance applied": "Tolerance applied",
    "General information": "General information",
    "Edit name": "Edit name",
    "Preparing your proposal...": "Preparing your proposal...",
    "Tolerance set for this campaign; adjust it from the Ad library step": "Tolerance set for this campaign; adjust it from the Ad library step",
    "Are you sure you want to delete this spot?": "Are you sure you want to stop using this ad in the campaign? You can add it again later.",
    "Are you sure you want to delete all progress so far? It will remove the loaded ads and created relationships.": "Are you sure you want to delete all progress so far? It will remove the loaded ads and created relationships.",
    "Delete": "Delete",

    //CardGeneralComponent
    "Total price": "Total price",

    // ScreenPreview
    "Add an Spot for this screen. (In case they meet the same rules, it will print once each)": "Add an ad for this screen. (In case they have the same rules, it will print once each)",
    "In programmatic the ads should not exceed the maximum time of the advertising space on the screen, otherwise they could be cut off in this time": "In programmatic the ads should not exceed the maximum time of the advertising space on the screen, otherwise they could be cut off in this time",
    "Exceeded in": "Exceeded in",
    "secs": "secs",
    "If you do not change the ad for a shorter one, it will add approximately": "If you do not change the ad for a shorter one, it will add approximately",
    "per day for this screen.": "per day for this screen.",
    "Expand ad": "Adjust material size to the resolution of the screen",
    "Stretch ad/s on group screens. This can distort the ads.": "Stretch ad/s on group screens. This can distort the ads.",
    "Do not stretch ad/s on the screens. Black spaces can be seen.": "Do not stretch ad/s on the screens. Black spaces can be seen.",
    "Stretch ad/s until they occupy 100% of the screen. This may distort the advertisement.": "Stretch ad/s until they occupy 100% of the screen. This may distort the advertisement.",
    "Do not stretch ad/s on the screen. Black spaces can be seen.": "Do not stretch ad/s on the screen. Black spaces can be seen.",
    "Stretch the ad until it fills 100% of the screen. This may distort the advertisement.": "Stretch the ad until it fills 100% of the screen. This may distort the advertisement.",
    "Do not stretch the ad on the screen. Black spaces can be seen.": "Do not stretch the ad on the screen. Black spaces can be seen.",
    "Time of each space on this screen. An extra fee may be charged if the advertisement exceeds this time.": "Time of each space on this screen. An extra fee may be charged if the advertisement exceeds this time.",
    "By enabling this option, the ad is subsidized, affecting the price of the campaign.": "By enabling this option, the ad is subsidized, affecting the price of the campaign.",
    "Return original resolution": "Return original resolution",
    "Ad created in canva, you can edit and change it for this screen or relationship.": "Ad created in canva, you can edit and change it for this screen or relationship.",
    "Create new ad in canva for this relationship": "Create new ad in canva for this relationship",
    "Change material": "Change material",
    "Change ad for this": "Change ad for this",
    "Change ad for this screens": "Change ad for this screens",
    "relationship": "relationship",
    "Remove spot": "Remove ad",
    "Screen detail": "Screen detail",
    "Remove screen": "Remove screen",
    "Remove screen from campaign": "Remove screen from campaign",
    "Add another rule": "Add another rule",
    "Add rule": "Add rule",
    "Configuration rules on": "Configuration rules on",
    "Remove rules": "Remove rules",
    "Clone rules": "Clone rules",
    "Standard time of the programmatic space, an extra could be charged in the case of a longer ad.": "Standard time of the programmatic space, an extra could be charged in the case of a longer ad.",
    "Screen space time": "Screen space time",
    "Space time": "Space length",
    "Standard time of the space of this screen, an extra could be charged in the case of being a longer ad.": "Standard time of the space of this screen, an extra could be charged in the case of being a longer ad.",
    "Potential reach in real time of the screen based on the measurement data with cameras, together with the dates and rules selected. Remember to optimize your campaign based on audience data. Also remember that the greater the number of spots, the greater impression you can achieve.": "Potential reach in real time of the screen based on the audience data, together with the dates and rules selected. Remember to optimize your campaign based on audience data. Also remember that the greater the number of playouts, the greater impression you can achieve.",
    "Real-time screen impressions, shows the number of people who will see your spot or group of spots based on camera measurement data, along with dates, selected rules, and investment made. Remember that the greater the investment, the greater the impact it will generate.": "Real-time screen impression, shows the number of people who will see your ad or group of ads based on audience data, along with dates, selected rules, and investment made. Remember that the greater the investment, the greater the impression it will generate.",
    "Audience data provided by the media. They are impression based on third-party measurement data. Remember to optimize your campaign based on audience data. Also remember that the more spots, the more impression you can achieve.": "Audience data provided by the publisher. Based on third-party measurement data. Remember to optimize your campaign based on audience data. Also remember that the more playouts, the more impression you can achieve.",
    "See screen detail to see the days and hours of operation, to optimize your rules": "See screen detail to see the days and hours of operation, to optimize your rules",
    "Subsidize price of this screen": "Subsidize price of this screen",
    "Subsidize price": "Subsidize price",
    "First load content for subsidize the campaign": "First load content for subsidize the campaign",
    "By enabling this option, the screen is subsidize, affecting the price of the campaign": "By enabling this option, the screen is rewarded, affecting the price of the campaign",
    "By enabling this option, the spot is subsidize, affecting the price of the campaign": "By enabling this option, the ad is subsidize, affecting the price of the campaign",
    "By enabling this option, the campaign is subsidize, your price will be zero": "By enabling this option, the campaign is subsidize, your price will be zero",
    "Avoid getting your ad disapproved, add %deference_cpm impressions to cover the CPM!": "Avoid getting your ad disapproved, add %deference_cpm playouts to cover the CPM!",
    "Congratulations! You reached the minimum CPM": "Congratulations! You reached the minimum CPM",
    "Congratulations! You exceeded the minimum CPM": "Congratulations! You exceeded the minimum CPM",
    "To delete need at least two screens in the campaign": "To delete need at least two screens in the campaign",
    "Setting this value in all screen and spot": "Setting this value in all screens and ads",
    "Add contents on the screen": "Add ads on the screen",
    "Add contents to screen group": "Add ads to screen group",
    "Set up rules in group of displays": "Set up rules in group of displays",
    "Set up rules in campaign": "Set up rules in campaign",
    "Rules in group of displays": "Rules in group of displays",
    "Rules in display": "Rules in display",
    "You must select at least one version": "You must select at least one version",
    "Clone spot": "Clone ad",
    "Rules tooltip": "Create and apply rules. Click on the <icon/> to learn how to do it.",


    // PaymentComponent
    "Error applying coupon": "Error applying coupon",
    "The coupon has already been applied": "The coupon has already been applied",
    "Coupon does not exist": "Coupon does not exist",
    "A coupon has already been applied in this campaign": "A coupon has already been applied in this campaign",
    "An error occurred while applying coupon": "An error occurred while applying coupon",
    "Coupon applied successfully": "Coupon applied successfully",
    "Failed to delete coupon": "Failed to delete coupon",
    "Coupon removed successfully": "Coupon removed successfully",
    "The campaign has already been paid.": "The campaign has already been paid.",
    "Congratulations! Your payment has been credited.": "Congratulations! Your payment has been credited.",
    "You must select a country": "You must select a country",
    "The month / year": "The month / year",
    "Its not valid": "It's not valid",
    "Campaign payment": "Campaign payment",
    "NAME LAST NAME": "NAME LAST NAME",
    "Pay by credit / debit card": "Pay by credit / debit card",
    "Pay with other means of payment": "Pay with other payment method",
    "Pay with Mercado Pago": "Pay with Mercado Pago",
    "Information for direct cash payments with": "Information for direct cash payments with",
    "Please complete the form with your billing information and your contact telephone number, a n_label collector will contact you to coordinate the collection.": "Please complete the form with your billing information and your contact telephone number, a n_label collector will contact you to coordinate the collection.",
    "Telephone contact": "Telephone contact",
    "Bank data": "Bank data",
    "Card number": "Card number",
    "Please make a transfer to the following account, and put the number as a reference": "Please make a transfer to the following account, and put the number as a reference",
    "Information for direct current account payments with": "Information for direct current account payments with",
    "Once the payment has been made using this method, your media manager will be able to approve the campaign.": "Once the payment has been made using this method, your media manager will be able to approve the campaign.",
    "Document type": "Document type",
    "Document number": "Document number",
    "export": "export",
    "Fill in the following information": "Fill in the following information",
    "Address": "Address",
    "Street": "Street",
    "Social name": "Name / Social name",
    "Number": "Number",
    "Province": "State",
    "Location": "Location",
    "Make a comment": "Make a comment",
    "Add here any comments you consider relevant to your campaign": "Add here any comments you consider relevant to your campaign",
    "Comment": "Comment",
    "Edit comment": "Edit comment",
    "Billing to client": "Client billing",
    "Billing to agency": "Agency billing",
    "Last billing": "Last billing",
    "Additional Information": "Additional Information",
    "Security code": "Security code",
    "Billing": "Billing",
    "Postal code": "Postal code",
    "Generate ODC": "Generate Purchase order",
    "Creating ODC": "Creating PO",
    "Created ODC": "Created PO",
    "Ups, problem for create ODC": "Ups, problem for create PO",
    "Try our new version": "Try our new version",

    // ODC modal
    "Purchase orders": "Purchase orders",
    "Date creation": "Date creation",
    "Files": "Files",
    "There are no purchase orders uploaded": "There are no purchase orders uploaded",
    "view": "View",
    "ODC": "PO",

    // PaymentTopbar
    "Go to map": "Go to map",

    // ScreenComponent
    "South": "South",
    "North": "North",
    "West": "West",
    "East": "East",
    "Northeast": "Northeast",
    "Northwest": "Northwest",
    "Southeastern": "Southeastern",
    "Southwest": "Southwest",
    "Class": "Class",
    "Middle": "Middle",
    "High": "High",
    "Lower": "Lower",
    "Mon": "Mon",
    "Tue": "Tue",
    "Wed": "Wed",
    "Thu": "Thu",
    "Fri": "Fri",
    "Sat": "Sat",
    "Sun": "Sun",
    "Off": "Off",
    "Remove from selection": "Remove",
    "Add to selection": "Add",
    "Go to buy": "Go to buy",
    "Description": "Description",
    "Information": "Information",
    "Resolution": "Resolution",
    "Ads time": "Ads time",
    "Length of ads time": "Length of ads time",
    "It is an approximate value, because is upload by screen owner.": "It is an approximate value, because is upload by publisher.",
    "There is no audience measurement configured": "There is no audience measurement configured",
    "Ad Duration": "Ad Duration",
    "Approximate impressions": "Approximate playouts",
    "Cost": "Cost",
    "Daily": "Daily",
    "Weekly": "Weekly",
    "Monthly": "Monthly",
    "No restrictions": "No restrictions",
    "Hide": "Hide",
    "Show": "Show",
    "Approx impr": "Approx. impr.",
    "It is an approximate value, because it depends on the days and rules you choose in your campaign. Once the campaign is created, you will get the exact impressions.": "It is an approximate value, because it depends on the days and rules you choose in your campaign. Once the campaign is created, you will get the exact playouts.",
    "Hours of Operation": "Hours of Operation",
    "Lit all day every day": "Lit all day every day",
    "Allowed ad format": "Allowed ad format",
    "Ad rotated": "Ad rotated",
    "to the right": "to the right",
    "to the left": "to the left",
    "Quality": "Quality",
    "Orientation": "Orientation",
    "Floor elevation": "Floor elevation",
    "meters": "meters",
    "Viewing distance": "Viewing distance",
    "Target": "Target",
    "Restrictions": "Restrictions",
    "Conditions": "Conditions",
    "Admit any ad or spot that respects everyday rules": "Admit any ad that respects everyday rules",
    "Live cameras": "Live cameras",
    "Today's traffic": "Today's traffic",
    "Live camera not available": "Live camera not available",
    "Traffic": "Traffic",
    "You have not configured a camera to measure the audience": "You have not configured a camera to measure the audience",
    "Show original": "Show original",
    "Translate to": "Translate to",
    "List of days": "List of days",
    "Details": "Details",
    "Daily audience": "Daily audience",
    "Weekly audience": "Weekly audience",
    "Monthly audience": "Monthly audience",
    "Map": "Map",
    "Table": "Table",
    "Multiple screens": "Multiple screens",
    "Without restrictions": "Without restrictions",
    "Cost per day": "Cost per day",
    "CPM impressions": "CPM impressions",
    "CPM spots": "CPM playouts",
    "Cost per thousand impressions": "Cost per thousand impressions",
    "Cost per thousand spot": "Cost per thousand playouts",
    "Cost per thousand impacts": "Cost per thousand impressions",


    // OnboardingComponent
    "Interest targeting": "Interest targeting",
    "Automobiles": "Automobiles",
    "Business": "Business",
    "Banking": "Banking",
    "Transport": "Transport",
    "Government": "Government",
    "Hospitality": "Hospitality",
    "Food": "Food",
    "Health & Beauty": "Health & Beauty",
    "Temperature": "Temperature",
    "Humidity": "Humidity",
    "Estimated audience for this location": "Estimated audience for this location",
    "Average per print": "Average per print",
    "Estimated traffic": "Estimated traffic",
    "Active screens": "Active screens",
    "Estimated audience": "Audience",
    "Screens with cameras measuring traffic and people": "Screens with cameras measuring traffic and people",

    // Map
    "Remember to zoom out the map to see more results": "Remember to zoom out the map to see more results",
    "Only screens that are within the visible area of the map will be displayed.": "Only screens that are within the visible area of the map will be displayed.",
    "If the screen is at its maximum capacity, at least your ad will be displayed": "If the screen is at its maximum capacity, at least your ad will be displayed",
    "times per hour. Otherwise it will display more": "times per hour. Otherwise it will display more",
    "Recommended duration": "Recom. duration",
    "An extra may be charged in the event that your ad times out on some screens": "An extra may be charged in the event that your ad times out on some screens",
    "Location, street or city": "Location, street or city",
    "Search on move": "Search on move",
    "Programmatic advanced filters": "Programmatic advanced filters",
    "Getting results": "Getting results",
    "Multiple faces screen": "Mirrored screen",
    "sides": "sides",
    "Circuit of n_screen screens": "Circuit of n_screen screens",
    "Selection filters": "Selection filters",
    "Map filters": "Map filters",
    "Results are filtered by country. You can": "Results are filtered by country. You can",
    "remove that filter and try again.": "remove that filter and try again.",
    "Search by place": "Search by place",
    "Refinate your search": "Refinate your search",
    "Add screens by ID": "Add screens by ID",
    "Screen IDs to add": "Screen IDs to add",
    "Screen IDs placeholder": "Enter the screen IDs you want to add. You can paste a list separated by spaces, commas, periods, semicolons, or copy a list from Excel",
    "Total screens": "Total screens",
    "screens added to cart": "{{count}} screen(s) added to cart",
    "screens already in cart": "{{count}} screen(s) already in cart",
    "screens added summary": "{{count}} screens added",
    "screens rejected summary": "{{count}} screens could not be added",
    "Already added to campaign": "Screen was already added to this campaign",
    "ID not found": "ID not found",
    "Screen archived": "Screen archived",
    "Secondary screen": "Secondary screen",
    "Screen not for sale": "Screen not for sale",
    "Campaign time too short": "Minimum campaign duration not met",
    "Not available for programmatic": "Not available for programmatic campaigns",

    // ScreenTypePreviewComponent
    "screens with": "screens with",
    "mixed content": "mixed content",
    "Exceeded on some screen": "Exceeded on some screen",
    "of": " of ",
    "The spot will be seen n_days days, with n_impressions impressions per days": "This material will be seen n_days days, with n_impressions playouts per day",
    "Unable to distribute due to lack of remaining prints": "Unable to distribute due to lack of remaining playouts",
    "Remaining to consume": "Remaining to consume",
    "Impressions details": "Playouts details",
    "Consumed": "Consumed",
    "To consumed": "To consumed",
    "Total material": "Total material",
    "Total display": "Total display",
    "Investment detail": "Investment detail",
    "Remaining": "Remaining",
    "Total on display": "Total on display",
    "Total on version": "Total on version",
    "Total material subsidized": "Total material subsidized",
    "day": "day",
    "days": "days",
    "You must select at least one day": "You must select at least one day",

    // Displays
    "Square": "Square",
    "Vertical": "Vertical",
    "Horizontal": "Horizontal",
    "Super horizontal": "Super horizontal",
    "The email entered already exists": "The email entered already exists",
    "Enter a valid email": "Enter a valid email",
    "The name must be less than 255 characters.": "The name must be less than 255 characters.",
    "The last name must be less than 255 characters.": "The last name must be less than 255 characters.",
    "The company name already exists. Please enter another.": "The company name already exists. Please enter another.",
    "Incorrect username or password": "Incorrect username or password",
    "Fill in all fields": "Fill in all fields",
    "We cant find that email in our database, try another one.": "We can't find that email in our database, try another one.",
    "Incorrect security code": "Incorrect security code",
    "The code must have 6 digits": "The code must have 6 digits",
    "Your account is not verified": "Your account is not verified",
    "This account has already been verified.": "This account has already been verified.",
    "Unexpected error": "Unexpected error",
    "Too many attempts": "Too many attempts",
    "Account is not activated": "Your account is not activated.",
    "Password changed": "You password has changed, please log in again",

    // Common
    "Good!": "Good!",
    "Changes successfully saved": "Changes successfully saved",
    "Loading": "Loading",
    "Go back": "Go back",
    "Edit": "Edit",
    "Close": "Close",
    "continue": "continue",
    "edit": "edit",
    "Create": "Create",
    "Categories": "Categories",
    "An error occurred, please try again": "An error occurred, please try again",
    "Token expired, please login again": "Token expired, please login again",
    "Reload": "Reload",
    "Cancel": "Cancel",
    "Confirm": "Confirm",
    "Contact us": "Contact us",
    "Remove": "Remove",
    "Add": "Add",
    "Can not be blank": "Can not be empty",
    "Select a category": "Select a category",
    "You must select a category": "You must select a category",
    "You must select a option": "You must select a option",
    "All screens must have at least some content": "All screens must have at least some content.",
    "You can not exeed 200 chars in this field": "You can not exeed 200 chars in this field",
    "seconds": "seconds",
    "persons": "persons",
    "Day": "Day",
    "unknown": "Unknown",
    "Print": "playout",
    "Prints": "playouts",
    "per print": "p/playout",
    "Results": "Results",
    "screen": "screen",
    "screens": "screens",
    "added": "added",
    "selected": "selected",
    "Show all screens": "Show all screens",
    "Hide Screens": "Hide Screens",
    "Some": "Some",
    "Payment method": "Payment method",
    "Campaign": "Campaign",
    "Select country": "Select country",
    "Education": "Education",
    "If you choose a DSP that is not LatinAd, you will only be able to make purchases in USD through an international invoice.": "If you choose a DSP that is not LatinAd, you will only be able to make purchases in USD through an international invoice.",
    "and": "and",
    "ad": "ad",
    "ads": "ads",
    "row": "row",
    "rows": "rows",
    "Previous page": "Previous",
    "Next page": "Next",
    // audience Dats Why
    "Female": "Female",
    "Male": "Male",
    "Other": "Other",
    "from 0 to 14": "from 0 to 14",
    "from 15 to 19": "from 15 to 19",
    "from 20 to 29": "from 20 to 29",
    "from 30 to 44": "from 30 to 44",
    "from 45 to 54": "from 45 to 54",
    "more than 55": "more than 55",
    "Level_A": "Level A",
    "Level_B": "Level B",
    "Level_C": "Level C",
    "Level_D": "Level D",
    "Level_E": "Level E",
    "NOT_SPECIFIED": "N_S",
    "Gender": "Gender",
    "Age": "Age",
    "Socioeconomic level": "Socioeconomic level",
    "Data obtained with the integration of": "Data obtained with the integration of",
    "Audience Hyper-Insights that help you plan, monitor, and analyze Out of Home sites and campaigns to maximize ROI.": "Audience Hyper-Insights that help you plan, monitor, and analyze Out of Home sites and campaigns to maximize ROI.",
    "General": "General",
    "Qualitative": "Qualitative",
    "By day of week": "By day of week",
    "Quantitative audience": "Quantitative audience",
    "Qualitative audience": "Qualitative audience",
    "Audience": "Audience",
    "Audience based on third-party measurement data": "Audience based on third-party measurement data.",
    "Third audience": "Third party audience",
    "Dats Why audience": "Dats Why Audience",
    "Audience summary": "Audience summary",
    "Data per month in the radius of the screen location": "Data per month in the radius of the screen location",
    "Total vehicle impressions": "Audience total vehicle impressions",
    "Unique vehicle impressions": "Unique vehicle impressions",
    "Frequency of unique people": "Frequency of unique people",
    "Total people impressions": "Audience total people impressions",
    "Impressions on unique people": "Impressions on unique people",
    "Average exposure in seconds": "Average exposure in seconds",

    // 404
    "We look everywhere for the page": "We look everywhere for the page",
    "(404 error)": "(404 error)",
    "Go to LatinAd": "Go to LatinAd",

    // Modal of currency - billing Conuntry
    "Language & Currency configuration": "Language & Currency configuration",
    "Language": "Language",
    "Billing Country": "Billing Country",
    "Apply settings": "Apply settings",
    "More": "More",
    "Dates": "Dates",
    "You will receive an international invoice without local taxes and the payment must be in USD (American Dollars) internationally.": "You will receive an international invoice without local taxes and the payment must be in USD (American Dollars) internationally. If there are expenses for WithHolding Taxes, they will be charged as an extra item and will be borne by the advertiser.",
    "International billing": "International billing",
    "Edition available on map": "Edition available on map",
    "Currency change": "Currency change",
    "Currency change explanation": "When changing the currency, you can <strong>keep the same amount</strong> of your budget without conversion, or <strong>adjust it automatically</strong> according to the exchange rate.",
    "Convert amount": "Convert amount",
    "Keep original amount": "Keep original amount",

    // POI - Points of interest
    "Bar & Coffee": "Bar & Coffee",
    "Beauty care": "Beauty care",
    "Entertainment": "Entertainment",
    "Finance": "Finance",
    "Health": "Health",
    "Institutions": "Institutions",
    "Restaurants": "Restaurants",
    "Services": "Services",
    "Shops": "Shops",
    "Transportation": "Transportation",
    "Vehicles": "Vehicles",

    // Info discount volume
    "2-7": " 2 to 7 days",
    "8-15": "8 to 15 days",
    "16-28": "16 to 28 days",
    "29-60": "from 29 days",
    "Volume discount": "Volume discount",
    "Discount applied": "Discount applied",
    "Volume discount applied": "Volume discount applied",
    "Increase n_diff_discount your campaign to access higher discounts": "Increase n_diff_discount your campaign to access higher discounts",
    "You already have all discounts applied!": "You already have all discounts applied!",
    "volume discount extraction limit": "Extraction limit: <strong>{{limit}}</strong> playouts. This screen has active volume discounts, so it is not possible to reduce more playouts.",
    "volume discount applied info": "This screen has <strong>volume discount</strong> applied. Minimum required: <strong>{{minSpots}}</strong> playouts/day to keep the discount.",
    "zero spots warning": "To set a screen to 0 playouts, you must first mark it as out of service or rejected. Contact the campaign control team.",
    "volume discount extraction limit impressions": "Extraction limit: <strong>{{limit}}</strong> impressions. This screen has active volume discounts, so it is not possible to reduce more impressions.",
    "volume discount extraction message impressions": "This screen has <strong>active volume discounts</strong>, so it is not possible to reduce more impressions once the discounts are applied.",
    "minimum investment extraction message impressions": "This screen has a <strong>minimum investment</strong>. It must keep at least <strong>{{minImpressions}}</strong> impressions ({{minInvestment}}) during the campaign, so it is not possible to extract below that value.",
    "volume discount applied info impressions": "This screen has <strong>volume discount</strong> applied. Minimum required: <strong>{{minImpressions}}</strong> impressions/day to keep the discount.",
    "volume discount applied info total impressions": "This screen has <strong>volume discount</strong> applied. Minimum required: <strong>{{minImpressions}}</strong> total impressions to keep the discount.",
    "zero impressions warning": "To set a screen to 0 impressions, you must first mark it as out of service or rejected. Contact the campaign control team.",
    "This screen has volume discounts configured, impressions will probably be added to it.": "This screen has volume discounts configured, impressions will probably be added to it.",

    // DiscountProgressBar
    "Add {{spots}} daily spots on this screen and get more benefits": "Add <spots>{{dailySpots}} daily playouts</spots> ({{totalSpots}} in total) on this screen and get <span>more benefits</span>!",
    "Add {{spots}} total spots on this screen and get more benefits": "Add <spots>{{totalSpots}} total playouts</spots> on this screen and get <span>more benefits</span>!",
    "Add {{impressions}} daily impressions on this screen and get more benefits": "Add <impressions>{{dailyImpressions}} daily impressions</impressions> ({{totalImpressions}} in total) on this screen and get <span>more benefits</span>!",
    "Add {{impressions}} total impressions on this screen and get more benefits": "Add <impressions>{{totalImpressions}} total impressions</impressions> on this screen and get <span>more benefits</span>!",
    "Add {{investment}} daily investment on this screen and get more benefits": "Add <investment>{{dailyInvestment}} a day</investment> ({{totalInvestment}} in total) on this screen and get <span>more benefits</span>!",
    "Add {{investment}} total investment on this screen and get more benefits": "Add <investment>{{totalInvestment}} of total investment</investment> on this screen and get <span>more benefits</span>!",
    "You reached the maximum benefits possible for this screen!": "You reached the maximum benefits possible for this screen!",

    // subtype
    "Sub Type of screen": "Sub Type of screen",
    "subtype_301": "Billboards",
    "subtype_302": "Urban Panels",
    "subtype_303": "Bus Shelters",
    "subtype_205": "Mall",
    "subtype_101": "Airports",
    "subtype_105": "Subway",
    "subtype_106": "Train Stations",
    "subtype_201": "Fueling Stations",
    "subtype_202": "Convenience Stores",
    "subtype_203": "Grocery",
    "subtype_207": "Pharmacies",
    "subtype_401": "Gyms",
    "subtype_402": "Salons",
    "subtype_501": "Doctor's Offices",
    "subtype_601": "Schools",
    "subtype_602": "Colleges and Universities",
    "subtype_701": "Office Buildings",
    "subtype_801": "Recreational Locations",
    "subtype_804": "Bars",
    "subtype_805": "Casual Dining",
    "subtype_1001": "Banks",
    "subtype_102": "Bus",
    "subtype_103": "Taxi",
    "subtype_104": "Taxi and Rideshare Top",
    "subtype_10202": "Terminal",
    "subtype_204": "Liquor Stores",
    "subtype_806": "QSR",
    "subtype_1": "Transit",
    "subtype_2": "Retail",
    "subtype_3": "Outdoor",
    "subtype_4": "Health & Beauty",
    "subtype_5": "Point of Care",
    "subtype_6": "Education",
    "subtype_7": "Office Buildings",
    "subtype_8": "Leisure",
    "subtype_9": "Government",
    "subtype_10": "Financial",
    "subtype_11": "Residential",
    "venue_category_other": "Others",

    //External DSP
    "info_dsp": "When selecting a DSP other than Latinad, the deal creation process may take between 3 to 6 hours to become active. Afterward, they will be ready for implementation on the selected DSP.",
    "info_payment_first": "By selecting a DSP other than Latinad",
    "info_payment_second": ", the campaign payment cannot be processed within this site; it must be done on the selected platform.",
    "info_payment_third": "The amount to invest in the campaign created in Latinad may not include the commissions of the chosen DSP, which may require the total assigned value to be higher to cover them.",

    // Verified agencies
    "Verified agency": "Verified agency",
    "Limited functionality": "Limited functionality",
    "Verified agencies text": "To access all platform-exclusive features, agencies need to be verified. For more information, please visit:",
    "The maximun duration of a traditional campaign for non-verfied agencies is limited to a week.": "The maximun duration of a traditional campaign for non-verfied agencies is limited to a week.",
    "Company is not verified and has more than $5000 USD in campaigns this month": "It's not possible to create this campaign. The company is not verified and has spend more than $5000 USD in campaigns this month",
    "The maximum budget for non verified agencies is 5000 USD a month": "The maximum budget for non verified agencies is 5000 USD a month.",
    "Unverified media company info": "Your company is not verified. When adding external screens to a campaign, the investment will be limited to 5000 USD per month for programmatic campaigns and campaign duration to one week for traditional campaigns.",
    "Unverified media company traditional limit": "Your company is not verified. When adding external screens to a traditional campaign, the duration is limited to one week. Reduce the campaign duration or remove the screens that do not belong to you.",
    "Unverified media company programmatic limit": "Your company is not verified. Monthly investment in external screens cannot exceed 5000 USD. Reduce the investment in screens that do not belong to you.",

    //Bundles
    "Sales bundles": "Sales bundles",
    "{{total}} sales bundle added": "{{total}} sales bundle added",
    "{{total}} sales bundles added": "{{total}} sales bundles added",
    "The following sales bundles were added with all of their screens.": "The following sales bundles were added with all of their screens.",
    "Sales bundle": "Sales bundle",
    "By name": "By name",
    "Sales bundle details": "Sales bundle details",
    "This screen belongs to the following bundles.": "This screen belongs to the following bundles.",
    "Traditional price": "Traditional price",
    "Programmatic price": "Programmatic price",
    "month": "month",
    "Delete to selection": "Delete to selection",
    "Number of screens": "Number of screens",
    "Delete to cart": "Delete to cart",
    "Type of bundle": "Type of bundle",
    "Displays of bundle": "Displays of bundle",
    "You can buy it only in a bundle (You will buy the entire bundle)": "You can buy it only in a bundle (You will buy the entire bundle)",
    "You can buy it individually or as a sales bundle (You will buy the entire bundle)": "You can buy it individually or as a sales bundle (You will buy the entire bundle)",
    "This screen belongs to the following packages.": "This screen belongs to the following packages.",
    "When deleting this screen, the packages to which it belongs, as well as the screens associated with those packages, will be automatically removed from the selection.": "When deleting this screen, the packages to which it belongs, as well as the screens associated with those packages, will be automatically removed from the selection.",
    "Belongs to the following packages": "Belongs to the following packages",

    //Budget transfer
    "All displays": "All displays",
    "Filter displays": "Filter displays",
    "Budget transfer": "Budget transfer",
    "By Ad": "By Ad",
    "By Display": "By Display",
    "Screen owners": "Publishers",
    "Consumed spots": "Consumed playouts",
    "Subtracted spots": "Subtracted playouts",
    "Added spots": "Added playouts",
    "Initial budget": "Initial budget",
    "Initial spots": "Initial playouts",
    "Available credit": "Available credit to transfer",
    "Apply changes": "Apply changes",
    "Pending spots": "Pending playouts",
    "Budget": "Budget",
    "You have available credit. You must use it to continue distributing.": "You have available credit. You must use it to continue distributing.",
    "Consumed credit. You can apply changes and edit. The remaining credit (n_credite) cannot be used to purchase 1 spot.": "Consumed credit. You can apply changes and edit. The remaining credit (n_credite) cannot be used to purchase 1 playout.",
    "Transfer the": "Transfer the",
    "of outputs from": "of outputs from",
    "to": "to",
    "Origin Version": "Origin Version",
    "Destination Version": "Destination Version",
    "Origin Screen": "Origin Screen",
    "Destination Screen": "Destination Screen",
    "All spots are forwarded to this version": "All playouts are forwarded to this version",
    "Shows the remaining promised spots": "Shows the remaining promised playouts",
    "CPM/spot": "CPM/playout",
    "Cost per spot": "Cost per playout",
    "Display {{displayName}} does not have {{version}}. Transfer was not applied.": "Display {{displayName}} does not have {{version}}. Transfer was not applied.",
    "Pending impressions": "Pending impressions",
    "Subtracted impressions": "Subtracted impressions",
    "Added impressions": "Added impressions",
    "of impressions from": "of impressions from",
    "All impressions are forwarded to this version": "All impressions are forwarded to this version",
    "Shows the remaining promised impressions": "Shows the remaining promised impressions",
    "CPM/impression": "CPM/impression",
    "Cost per impression": "Cost per impression",
    "Consumed credit. You can apply changes and edit. The remaining credit (n_credite) cannot be used to purchase more impressions.": "Consumed credit. You can apply changes and edit. The remaining credit (n_credite) cannot be used to purchase more impressions.",

    // Audience provider info
    "Audience data for these screens provided by": "Audience data for these screens provided by",
    "Audience data for this screen provided by": "Audience data for this screen provided by",
    "display owner": "the publisher",
    "Average audience by days of the week": "Average audience by days of the week",
    "Average audience by hours": "Average audience by hours",
    "There is no audience data available": "There is no audience data available",
    "There is no audience data for this screen": "There is no audience data for this screen",
    "There is no audience data for these screens": "There is no audience data for these screens",

    // Rules component
    "Rules": "Rules",
    "Days of the week": "Days of the week",
    "Create rules": "Create rules",
    "Assign spots": "Assign playouts",
    "Automatically assigns the entered output frequency to all screens.": "Automatically assigns the entered output frequency to all screens.",
    "Assign playouts tooltip": "The {{qualifier}} playouts will be distributed evenly across the creatives, aiming to keep a similar exhibition frequency. In PMP campaigns, frequency may vary depending on each screen's audience.",
    "Impressions to assign": "Impressions",
    "Rules in campaign": "Rules in campaign",
    "Name of the rule": "Name of the rule",
    "Create new rules": "Create new rules",
    "Rules applied in all campaign": "Rules applied in all campaign {{versions}}",
    "ruleAppliedAllVersions": "Rule applied to all screens: {{versions}}",
    "ruleAppliedSomeVersions": "Rule applied in all campaign {{versions}} and others, expand group to see",
    "ruleAppliedSomeRelations": "Rule applied to some screens. Expand group to see",
    "New rules": "New rules",
    "Remove rule": "Remove rule",
    "Set up rules in this display": "Set up rules in this display",
    "Set up rules in this spot": "Set up rules in this ad",
    "displays": "displays",
    "display": "display",
    "spots": "playouts",
    "impressions": "impressions",
    "Spots": "Ads",
    "Spots Card": "Playouts",
    "Frequency": "Frequency",
    "Applying in display": "Applying in display",
    "Applying in spot": "Apply rules to ad",
    "Applying in group": "Applying in group",
    "Applying in campaign": "Applying in campaign",
    "There are no general rules for this group": "There are no general rules for this group",
    "There are no general rules for this display": "There are no general rules for this display",
    "There are no rule for this spot": "There are no rule for this ad",
    "Without rules in group": "Without rules in group",
    "Without rules in display": "Without rules in display",
    "Without rules": "Without rules",
    "Rule(s) applied": "Rule(s) applied",
    "Other applied rule(s)": "Other applied rule(s)",
    "throughout the group": "throughout the group",
    "throughout the display": "throughout the display",
    "Content name": "Content name",
    "Spot resolution": "Ad resolution",
    "Ad name": "Ad name",
    "Not rules created": "Not rules created",
    "The name of the rule already exists": "The name of the rule already exists",
    "The name of the rule is required": "The name of the rule is required",
    "Applied rule": "Applied rule",
    "Save": "Save",
    "Save and apply": "Save and apply",
    "You are about to permanently remove this rule from the list. This action cannot be undone": "You are about to permanently remove this rule from the list. This action cannot be undone",
    "Delete all campaign rules": "Delete all campaign rules",
    "Are you sure you want to delete all rules? This action is irreversible": "Are you sure you want to delete all rules? This action is irreversible",

    // Screens Group
    "Removing this spot will redistribute the impressions among the remaining spots.": "Removing this ad will redistribute the playouts among the remaining ads.",
    "The ad will be removed from the screen, and the spots will be redistributed among the other versions. You can add it again from the previous Ads step or by clicking the Add Ad button.": "The ad will be removed from the screen, and the playouts will be redistributed among the other versions. You can add it again from the previous Ads step or by clicking the 'Add Ad' button.",
    "The ad will be removed from the screen, and the spots will be redistributed among the other versions. You can add it again from the previous Ads step or by clicking the Add Ad button._cpmi": "The ad will be removed from the screen, and the impressions will be redistributed among the other versions. You can add it again from the previous Ads step or by clicking the 'Add Ad' button.",
    "You are going to remove this screen from the campaign": "By removing this screen, it will no longer be in the campaign. You can add it back from the map step.",
    "Are you sure you want to delete?": "Are you sure you want to delete?",
    "You are going to remove this group of screens from the campaign": "You are going to remove this group of screens from the campaign",
    "Remove group of screens": "Remove group of screens",
    "By removing the group, all screens within this group will be removed from the campaign.": "By removing the group, all screens within this group will be removed from the campaign.",
    "To delete need at least two group in the campaign": "To delete need at least two group in the campaign",
    "Remove group": "Remove group",
    "Investment of content": "Investment of content",
    "Content version": "Content version",
    "Distribute by": "Distribute by",
    "Total investment for this screen": "Total investment for this screen",
    "None": "None",
    "Countries": "Countries",
    "Province/State": "Province/State",
    "This screen does not accept contents of type": "This screen does not accept contents of type",
    "image": "imagen",
    "video": "video",
    "html": "html",
    "Balance impressions": "Balance impressions",
    "Equalize the frequency across all screens, at the exact amount that keeps the campaign budget up to date.": "Equalize the frequency across all screens, at the exact amount that keeps the campaign budget up to date.",
    "You're about to equalize the spots across all screens, which will modify any previous spot distribution. Do you wish to continue?": "You're about to equalize the playouts across all screens, which will modify any previous playout distribution. Do you wish to continue?",
    "Balance playouts tooltip": "The same amount of {{qualifier}} playouts will be distributed across each creative, running a calculation to keep the budget on target and aiming for a similar exhibition frequency. In PMP campaigns, frequency may vary depending on each screen's audience.",
    "Confirm balance playouts body": "You're about to assign {{qualifier}} playouts evenly across every creative without changing the total adjusted budget, but any previous distribution of investment and impressions per creative, screen or group will be lost. Do you wish to continue?",
    "Confirm balance playouts title": "Confirm frequency balance",
    "Balance": "Balance",
    "Impressions will be distributed equally depending on the updated budget": "Impressions will be distributed equally depending on the updated budget",
    "When setting the amount for (n_type), it will not be modified during the automatic budget redistribution. It can be adjusted manually at any time.": "When setting the amount for {{n_type}}, it will not be modified during the automatic budget redistribution. It can be adjusted manually at any time.",
    "If the amount for (n_type) is not fixed, it may be modified during the automatic budget redistribution. It can also be adjusted manually at any time.": "If the amount for {{n_type}} is not fixed, it may be modified during the automatic budget redistribution. It can also be adjusted manually at any time.",
    "this display": "this display",
    "this spot": "this ad",
    "this displays group": "this displays group",
    "Distributed by": "Distributed by",
    "This indicates what percentage of the campaign’s total budget corresponds to the investment assigned to this group. You can modify it by editing either the investment or directly the percentage.": "This indicates what percentage of the campaign’s total budget corresponds to the investment assigned to this group. You can modify it by editing either the investment or directly the percentage.",
    "This indicates what percentage of the total budget allocated to this grouping corresponds to the investment assigned to this group. You can modify it by editing either the investment or directly the percentage.": "This indicates what percentage of the total budget allocated to this grouping corresponds to the investment assigned to this group. You can modify it by editing either the investment or directly the percentage.",
    "This indicates what percentage of the total budget allocated to the group corresponds to the investment assigned to this screen. You can modify it by editing either the investment or directly the percentage.": "This indicates what percentage of the total budget allocated to the group corresponds to the investment assigned to this screen. You can modify it by editing either the investment or directly the percentage.",

    // CardCampaignStatusComponent
    "Campaign status": "Campaign status",
    "Status": "Status",
    "approved": "Approved",
    "pending": "Pending",
    "ready": "Active",
    "cancelled_by_user": "Cancelled by user",
    "cancelled": "Cancelled",
    "paused": "Paused",
    "in progress": "In progress",
    "Pause content": "Pause content",
    "Resume content": "Resume content",
    "Pause campaign": "Pause campaign",
    "Resume campaign": "Resume campaign",
    "Pause Display": "Pause Display",
    "Resume Display": "Resume Display",

    // ContentSpecificationAlertComponent
    "Some content does not meet the specifications on one or more screens in this group": "Some content does not meet the specifications on one or more screens in this group.",
    "Some content does not meet the specifications on this screen": "Some content does not meet the specifications on this screen",
    "Some content does not meet the specifications on one or more screens": "Some content does not meet the specifications on one or more screens",

    // ImageModalList
    "Number of ads on this screen": "Number of ads on this screen",

    // CheckCompanyForUserComponent
    "Different companies": "Different companies",
    "The company logged into the system (n_company) does not match the one you have in the DSP (n_company_check). You will be redirected to avoid errors.": "The company logged into the system (n_company) does not match the one you have in the DSP (n_company_check). You will be redirected to avoid errors.",

    // Error Boundary
    "An unexpected error has occurred": "An unexpected error has occurred.",
    "To continue browsing, please press the button to return to the previous page. We are working to improve your experience on our platform. Thank you for your understanding!": "To continue browsing, please press the button to return to the previous page. We are working to improve your experience on our platform. Thank you for your understanding!",
    "Resume browsing": "Resume browsing",
    "Clear caché": "Clear caché",

    //Modal new version
    "DISCOVER": "DISCOVER",
    "the new way to": "the new way to",
    "launch your": "launch your",
    "CAMPAIGN!": "CAMPAIGN!",
    "Faster": "Faster",
    "Smarter": "Smarter",
    "Easier to use": "Easier to use",
    "TRY THE NEW": "TRY THE NEW",
    "VERSION NOW!": "VERSION NOW!",
    "View guide": "View guide",

    //Moda Change Dates
    "Attention Outbound rules updated automatically": "Attention: Outbound rules updated automatically",
    "You've edited the campaign's start and end dates. If the campaign has output rules configured, the dates for those rules have been automatically adjusted to match the new range.": "You've edited the campaign's start and end dates. If the campaign has output rules configured, the dates for those rules have been automatically adjusted to match the new range.",
    "However, we recommend reviewing these rules manually to ensure they remain aligned with your campaign goals.": "However, we recommend reviewing these rules manually to ensure they remain aligned with your campaign goals.",

    // ChangeAdsModalComponent
    "Add ad": "Add ad",
    "Change add": "Change add",
    "Expand ad to fill the screen": "Expand ad to fill the screen",
    "Assign rule": "Assign rule",
    "Are you sure you want to change this ad?": "Are you sure you want to change this ad?",
    "By selecting this option, the promised spots and remaining investment will be transferred to the new ad. The current ad will remain in 'Inactive' status and will retain the history of past spots. You can confirm to continue or cancel if you wish to keep the current ad.": "By selecting this option, the promised playouts and remaining investment will be transferred to the new ad. The current ad will remain in 'Inactive' status and will retain the history of past playouts. You can confirm to continue or cancel if you wish to keep the current ad.",
    "Do you want to add this ad to the screen?": "Do you want to add this ad to the screen?",
    "Upon confirmation, a new ad will be added as a new version within this screen. The remaining promised spots from other ads will be distributed equally among all active ads on the screen. If you prefer to allocate a specific number of spots to each ad, you can do so from the 'Edit Campaign' option.": "Upon confirmation, a new ad will be added as a new version within this screen. The remaining promised playouts from other ads will be distributed equally among all active ads on the screen. If you prefer to allocate a specific number of playouts to each ad, you can do so from the 'Edit Campaign' option.",
    "I don't have my ads": "<strong>I don't have my ad:</strong><br/>If you activate this button, the ad will be in \"on hold\" status, meaning you don't have the ad for this screen yet. This means that the approval email will not be sent to the publisher until you upload the final ad and save the changes.",
    "Pending ad": "<strong>Ad on hold:</strong><br/>While this status is active, the approval email will not be sent to the publisher. When you replace the ad with the final version, this status will be automatically deactivated and the corresponding approval email will be sent when saving the changes.",

    // IA SMART PLANNER
    "Optimize": "Optimize",
    "Optimize rules": "Optimize rules",
    "Optimizing campaign...": "Optimizing campaign...",

    // Optimize rules wizard
    "Rule type": "Rule type",
    "Schedule": "Schedule",
    "Min. hours": "Min. hours",
    "Schedule mode": "Schedule mode",
    "Minimum active hours": "Minimum active hours",
    "Choose how to apply optimization rules across your screens": "Choose how to apply optimization rules across your screens",
    "General rule": "General rule",
    "Apply the same rule to all campaign screens": "Apply the same rule to all campaign screens",
    "Individual rule": "Individual rule",
    "Create a separate rule for each screen": "Create a separate rule for each screen",
    "Group rule": "Group rule",
    "Group screens by a common criteria": "Group screens by a common criteria",
    "Select grouping criteria": "Select grouping criteria",
    "Country": "Country",
    "State / Province": "State / Province",
    "City": "City",
    "Company": "Company",
    "Choose the scheduling pattern for your rules": "Choose the scheduling pattern for your rules",
    "Weekly schedule": "Weekly schedule",
    "One rule covering the entire week with the same time slots": "One rule covering the entire week with the same time slots",
    "Daily schedule": "Daily schedule",
    "Separate rules for each day of the week based on audience patterns": "Separate rules for each day of the week based on audience patterns",
    "Minimum active hours per day": "Minimum active hours per day",
    "Minimum active hours per week": "Minimum active hours per week",
    "Calculate": "Calculate",
    "Optimization results": "Optimization results",
    "Rules created": "Rules created",
    "Estimated shows": "Estimated shows",
    "Estimated reach": "Estimated reach",
    "This action will replace all existing rules in the campaign": "This action will replace all existing rules in the campaign",
    "Some screens have no audience data": "Some screens have no audience data",
    "The following screens could not be optimized": "The following screens could not be optimized due to missing audience data",
    "No rules could be created as no screens have audience data available": "No rules could be created as no screens have audience data available",
    "Apply rules": "Apply rules",
    "Error optimizing rules": "Error optimizing rules",
    "No audience data available to optimize": "No audience data available to optimize",
    "Confirm optimization": "Confirm optimization",
    "All existing rules in the campaign will be replaced with the optimized ones. Do you wish to continue?": "All existing rules in the campaign will be replaced with the optimized ones. Do you wish to continue?",

    //Guaranteed DSP campaigns
    "Programmatic PMP": "Programmatic PMP",
    "Programmatic PG": "Programmatic PG",
    "Guaranteed Campaign": "Guaranteed Campaign",
    "You guarantee the delivery of a defined number of screen appearances on specific dates and times. Inventory is reserved and the campaign takes priority to fulfill the contract, with total predictability.": "Ensures delivery of a defined investment in specific screens, dates, and times. Inventory is reserved in advance and the campaign has priority placement to fulfill the contract, offering total predictability in delivery.",
    "I have read and accept the terms and conditions of the Guaranteed Campaign.": "I have read and accept the <a>terms and conditions</a> of the Guaranteed Campaign.",
    "You must accept the terms and conditions for a guaranteed campaign.": "You must accept the terms and conditions for a guaranteed campaign.",
    "Guaranteed programmatic": "Guaranteed programmatic",
    "Private agreement": "Private agreement",
    "Campaign type": "Campaign type",
    "Exchange": "Exchange",
    "Campaign created as guaranteed programmatic": "Campaign created as guaranteed programmatic",
    "Campaign created as a private agreement": "Campaign created as a private agreement",
    "For guaranteed campaigns, only Magnite DSPs are permitted.": "For guaranteed campaigns, only Magnite DSPs are permitted.",

    // Screen replacement
    "Change ad title": "Change ad",
    "Change ad button": "Change ad",
    "When changing the ad, the current one will become inactive and the promised outputs that have not yet been executed will be assigned to the new ad, which will be incorporated as a new version within the same campaign.": "When changing the ad, the current one will become inactive and the promised outputs that have not yet been executed will be assigned to the new ad, which will be incorporated as a new version within the same campaign.",
    "This ad version is inactive and cannot be replaced": "This ad version is inactive and cannot be replaced",
    "This ad is inactive on all screens": "This ad is inactive on all screens",
    "This ad is linked to another screen. The change will only be made for this/these relationship(s) to avoid modifying the one currently in use. The current one will be deactivated and the promised outputs that have not yet been executed will be assigned to the new ad, which will be incorporated as a new version within the same campaign.": "This ad is linked to another screen. The change will only be made only for this/these relationship(s) to avoid modifying the one currently in use. The current one will be deactivated and the promised outputs that have not yet been executed will be assigned to the new ad, which will be incorporated as a new version within the same campaign.",
    "The selected version is inactive. Please select a valid version.": "The selected version is inactive. Please select a valid version.",
    "You cannot replace the content of a screen that is inactive. Please select a valid version.": "You cannot replace the content of a screen that is inactive. Please select a valid version.",
    "The new version has only been incorporated into those screens that had the previous version active.": "The new version has only been incorporated into those screens that had the previous version active.",
    "The new ad does not match the resolution of any of the screens. No changes were made.": "The new ad does not match the resolution of any of the screens. No changes were made.",
    "The ad was only changed on screens where the resolution matched. On the rest, the original version was kept.": "The ad was only changed on screens where the resolution matched. On the rest, the original version was kept.",
    "Apply tolerance": "Apply tolerance",

    //NEW CHECKOUT
    "Programmatic campaign": "Programmatic campaign",
    "Finish proposal": "Finish Proposal",
    "Amounts": "Amounts",
    "Subtotal": "Subtotal",
    "Total budget": "Total budget",
    "Planned impressions (%)": "Impresiones planificadas (%)",
    "Planned impressions percentage tooltip": "Porcentaje de impresiones alcanzada con el presupuesto entregado y CPM negociado. Cuando mayor sea la inversión, mayor el porcentaje de impresiones que podrás generar",
    "Maximum available impressions tooltip": "Impresiones máximas proyectadas considerando periodo, número de ubicaciones y frecuencia",
    "Age Range": "Age Range",
    "Unique people frequency": "Unique people frequency",
    "Projected reach": "Alcance proyectado",
    "Projected reach tooltip": "Cantidad proyectada de personas únicas expuestas a los anuncios de la campaña en el circuito de pantallas seleccionada durante el periodo seleccionado",
    "Investment by screen type": "Investment by screen type",
    "Investment distribution by screen type.": "Investment distribution by screen type.",
    "Investment by screen subtype": "Investment by screen subtype",
    "Investment distribution by screen subtype.": "Investment distribution by screen subtype.",
    "Investment by media owner": "Investment by publisher",
    "Investment distribution by media owner (only visible to Super Admins).": "Investment distribution by publisher (only visible to Super Admins).",
    "Screen list ({count})": "Screen list",
    "Showing {{shown}} of {{total}}": "Showing {{shown}} of {{total}}",
    "Showing {{shown}} of {{total}} screens": "Showing {{shown}} of {{total}} screens",
    "Showing {{shown}} of {{total}} clients": "Showing {{shown}} of {{total}} clients",
    "Spot": "Ad",
    "Screen": "Screen:",
    "Investment": "Investment:",
    "Campaign performance": "Campaign performance",
    "Day of greatest reach": "Day of greatest reach",
    "Day of the week with the highest projected reach.": "Day of the week with the highest projected reach.",
    "Highest reach day": "Highest reach day",
    "Total number of impressions on the best day.": "Total number of impressions on the best day.",
    "Time of greatest reach": "Time of greatest reach",
    "Time slot with the highest projected reach.": "Time slot with the highest projected reach.",
    "Highest hourly reach": "Highest hourly reach",
    "Number of impressions in the best time slot.": "Number of impressions in the best time slot.",
    "No data available": "No data available.",
    "Save changes": "Save changes",
    "Save & Pay": "Save & Pay",
    "Confirm & Pay": "Confirm & Pay",

    //CAMPAIGN DATES
    "Attention: Review the impression rules.": "Attention: Review the impression rules.",
    "You have modified the campaign start and/or end date.": "You have modified the campaign start and/or end date.",
    "The configured impression rules were automatically adjusted to match the new date range.": "The configured impression rules were automatically adjusted to match the new date range.",
    "Important:": "Important:",
    "We recommend manually reviewing the impression rules, especially the days of the week and time slots, to ensure they remain aligned with the campaign objective.": "We recommend manually reviewing the impression rules, especially the days of the week and time slots, to ensure they remain aligned with the campaign objective.",
    "Automatic adjustments do not take strategic planning changes into account.": "Automatic adjustments do not take strategic planning changes into account.",

    // FILTERS 
    "No limits applied": "No limits applied",
    "Price range": "Price range",
    "Purchase type": "Purchase type",
    "Per day": "Per day",
    "Per spot/output": "Per playout",
    "Per CPM impression": "Per CPM impression",
    "From": "From",
    "To": "To",
    "Screens": "Screens",
    "Type": "Type",
    "Subtype": "Subtype",
    "Select": "Select",
    "Resolutions": "Resolutions",
    "Other resolution": "Other resolution",
    "Ad format": "Ad format",
    "Image": "Image",
    "Video": "Video",
    "HTML": "HTML",
    "Size": "Size",
    "Small": "Small",
    "Medium": "Medium",
    "Large": "Large",
    "Giant": "Giant",
    "Circuit": "Circuit",
    "Ad duration range": "Ad duration range",
    "Seconds": "Seconds",
    "Clear filters": "Clear filters",
    "Apply": "Apply",
    "Media owner": "Publisher",



    // NEW FILTERS DESIGN & LOGIC
    "General configuration": "General configuration",
    "Filters": "Filters",
    "Show all": "Show all",
    "Aspect ratio": "Aspect ratio",
    "Resolution tooltip": "Select resolutions from the list. To add custom resolutions not listed, type them in the 'Other resolution' field separated by commas (e.g., 100x100, 200x200).",
    "Aspect ratio tooltip": "If enabled, screens will be filtered by matching the aspect ratio of the selected resolutions within the defined tolerance. If disabled, aspect ratio is ignored.",
    "Tolerance tooltip": "Defines the percentage of margin allowed when matching screen resolutions. Empty equals 0%.",
    "Unknown Media Owner": "Unknown Publisher",
    "By activating this option, you confirm that the investment assigned to this company is secured and must be fulfilled by the end of the campaign.": "By activating this option, you confirm that the investment assigned to this company is secured and must be fulfilled by the end of the campaign.",
    "Secured investment.": "Secured investment.",
    "Secured investment for this screen must be fulfilled by the end of the campaign.": "Secured investment for this screen must be fulfilled by the end of the campaign.",
    "This medium works with secured investment.": "This publisher operates on a guaranteed payment basis, so LatinAd commits to paying the agreed-upon amount. The agency or advertiser’s investment commitment must be secured. Whenever possible, guaranteed campaigns should be created when dealing with publishers that offer guaranteed payments.",
    "This screen is secured.": "This screen is secured.",
    "This group has screens with secured investment.": "This group has screens with secured investment.",

    "View proposal": "View proposal",
    "View proposal generated for this campaign": "View proposal generated for this campaign",

    //CHATBOT -IA
    "AI Assistant": "AI Assistant",
    "ChatbotSubtitle": "Your campaign copilot",
    "ChatbotWelcome": "Hi! I'm your AI assistant. I can help you add or remove screens, answer questions about your cart, and change campaign settings. How can I help?",
    "ChatbotPlannerGreeting": "Hi! 👋 I'm here to help.\n\nYou can select one of the options below to get started. I can also guide you through the process.\n\nIf you'd rather do it manually, you can close this chat at any time.",
    "ChatbotMockReply": "I'm still being set up and can't perform that action yet, but I'll be able to help you with it soon.",
    "Type a message": "Type a message",
    "Add screens": "Add screens",
    "Remove screens": "Remove screens",
    "Summarize cart screens": "Summarize cart screens",
    "Change budget": "Change budget",
    "Change campaign data": "Change campaign data",
    "ChatbotReset": "Restart chat",
    "ChatbotResetWarning": "The session is about to expire. Restart the chat to continue.",
    "ChatbotSessionExpired": "The session expired. The chat history has been reset.",
    "ChatbotConfirm": "Confirm",
    "ChatbotReject": "Reject",
    "ChatbotProposalAdd": "The assistant proposes adding these screens:",
    "ChatbotProposalDelete": "The assistant proposes removing these screens:",
    "ChatbotProposalBudget": "The assistant proposes changing the budget:",
    "ChatbotProposalDates": "The assistant proposes changing the campaign dates:",
    "ChatbotProposalType": "The assistant proposes changing the campaign type:",
    "ChatbotProposalClient": "The assistant proposes changing the client to:",
    "ChatbotProposalBrand": "The assistant proposes changing the brand to:",
    "ChatbotProposalDsp": "The assistant proposes changing the external DSP to:",
    "ChatbotError": "There was an error. Please try again.",

    "Select the ads to add": "Select the ads to add",
    "Review of duplicate ads": "Review of duplicate ads",
    "Select all ads": "Select all ads",
    "Select all": "Select all",
    "Zoom in to see the screens in a table": "Zoom in to see the screens in a table",
    "If you select more than one ad per resolution, new versions will be created automatically.": "If you select more than one ad per resolution, new versions will be created automatically.",
    "Keep all": "Keep all",
    "Add selected": "Add selected",
    "You must select at least one ad per resolution": "You must select at least one ad per resolution",
    "You must select at least one ad": "You must select at least one ad",
    "ads added to campaign": "ads added",
    "new versions created": "new versions created",
    "Add all ads from folder": "Add all ads from folder",
    "Select a folder to add all its ads": "Select a folder to add all its ads",
    "No content in folder": "No ads in this folder",
    "Error loading folder contents": "Error loading ads from folder",
    "ads replaced": "ads replaced",
    "relations updated": "relations updated",
    "contents omitted because target version is inactive": "ads omitted because their target version is inactive",
    "Currently in campaign": "Currently in campaign",
    "Selected ads will deactivate the current versions, preserving already delivered spots.": "Selected ads will deactivate the current versions, preserving already delivered playouts.",
    "Selected ads will replace the current versions. Additional selections become new versions.": "Selected ads will replace the current versions. Additional selections become new versions.",
    "All ads from this folder were already added in this session": "All ads from this folder were already added in this session",
    "ads omitted because no compatible display in approved campaign": "ads omitted: no compatible display in the approved campaign",
    "Draw area to add screens": "Draw area to add screens",
    "Select area": "Select area",
    "Delete area": "Delete area",
}
